/* bust:1786100000 */

var PRODUCTS = [
{
    "handle": "e1101c-hemlock-180x180-9kw-cilindro",
    "title": "E1101C Hemlock 180x180 9kW Cilindro",
    "price": "5.999,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/e6/8b/d1/1749161008/925aea0d617609f3ee5f6e3907eb3f72.jpg?ts=1749161008",
    "bg_id": "16592",
    "imgs": [
      "https://www.eago.de/media/e6/8b/d1/1749161008/925aea0d617609f3ee5f6e3907eb3f72.jpg?ts=1749161008",
      "https://www.eago.de/media/ef/4d/85/1749161010/98c1d398b430cc895dde1988465d7f73.jpg?ts=1749161010",
      "https://www.eago.de/media/ef/92/b3/1749161011/8c907ed8e01bd8abd66115f2ce9fc309.jpg?ts=1749161011",
      "https://www.eago.de/media/3c/72/49/1749161011/eabe922ebdc6878b591db82e67bf478c.jpg?ts=1749161011",
      "https://www.eago.de/media/73/bf/a7/1749161012/a031ee4c85055a60148b69337a70d0d0.jpg?ts=1749161012",
      "https://www.eago.de/media/28/e1/0b/1749161012/af3f1b77170ed0c5d371afdaf0ac3340.jpg?ts=1749161012",
      "https://www.eago.de/media/b0/02/4e/1749161013/83759b70039e1579d6840f5479116b51.jpg?ts=1749161013",
      "https://www.eago.de/media/8b/e2/df/1749161013/1f8595c6fc15e5ed98c6779449d215c8.jpg?ts=1749161013",
      "https://www.eago.de/media/d7/33/ce/1749161014/3c5367d55a4cbd850f9f1102efa62637.jpg?ts=1749161014",
      "https://www.eago.de/media/ac/9d/23/1749161014/e681fb57d61e93fd79becea734147359.jpg?ts=1749161014"
    ],
    "pdf": "https://cdn.shopify.com/s/files/1/1056/1306/6585/t/8/assets/awt-e11xx-stone.pdf",
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (5-Eck)",
      "Ofenleistung": "9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Schrauben": "M3×16 (12 St.), M3,5×35 (35 St.), M4×50 (20 St.), M8×120 (10 St.)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16592"
    },
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock Holz (Kanadische Hemlocktanne)",
                  "Sandstein-Rückwand links und rechts (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Vorbereitete Kabelkanäle für Ofen und LED-Strips",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Montage – Schritt für Schritt (1101A/B/C)",
            "items": [
                  "1. Boden prüfen: ebene Standfläche sicherstellen",
                  "2. Steinrückwände montieren: zuerst unteren, dann oberen Teil links/rechts einsetzen und verschrauben (M8×120)",
                  "3. Rahmen aufbauen: untere/seitliche Rahmen verschrauben, einhängen, Türrahmen unten montieren, große Glaselemente einsetzen",
                  "4. Obere Rahmen: alle 3 (links, rechts, Tür) anbringen, kleine Scheiben einsetzen – Tür noch nicht montieren",
                  "5. Dachelemente montieren und verschrauben",
                  "6. Sitzunterkonstruktionen: zuerst oben (Bankunterbauten + Blenden), dann unten (M4×50, M3,5×35)",
                  "7. Ofen & Beleuchtung anschließen (Kabelkanäle nutzen, nur durch Fachbetrieb)",
                  "8. Sitze und Rückenlehnen montieren und verschrauben",
                  "9. Glastür + Griffe montieren, Dachplatte anbringen (Glaswolle zur Dämmung empfohlen, nicht im Lieferumfang)"
            ]
      },
      {
            "h": "Erstinbetriebnahme",
            "items": [
                  "Beim ersten Aufheizen Gerüche durch gründliches Lüften entfernen",
                  "Saunasteine vor dem Einlegen von Steinstaub befreien (Ø 5–10 cm)",
                  "Steine so schichten, dass Heizelemente vollständig bedeckt sind – nie zwischen die Heizelemente klemmen",
                  "Während des ersten Aufheizens Sauna verlassen",
                  "Steine mind. 1× jährlich neu aufschichten (bei Intensivnutzung öfter)",
                  "Empfohlene Betriebstemperatur: 60–90 °C, nie über 95 °C"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
  },
{
    "handle": "e1102c-hemlock-180x150-9kw-cilindro",
    "title": "E1102C Hemlock 180x150 9kW Cilindro",
    "price": "5.999,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/ca/c5/3b/1749161095/40e4ef390df776ca841d2d05ab9bab10.jpg?ts=1749161095",
    "bg_id": "16595",
    "imgs": [
      "https://www.eago.de/media/ca/c5/3b/1749161095/40e4ef390df776ca841d2d05ab9bab10.jpg?ts=1749161095",
      "https://www.eago.de/media/87/23/39/1749161097/a6acbe441c6c3ea6318b4d003f898009.jpg?ts=1749161097",
      "https://www.eago.de/media/a2/87/f0/1749161097/52c66d91c8c2054519c7c200f9bbca55.jpg?ts=1749161097",
      "https://www.eago.de/media/cf/85/f0/1749161098/26fd60043825944bf65030452c8bfc00.jpg?ts=1749161098",
      "https://www.eago.de/media/2d/0c/85/1749161098/908b88807e054c5e6ca78ab7f21a608d.jpg?ts=1749161098",
      "https://www.eago.de/media/11/cc/08/1749161099/08891a1263c0d2292ae4e5d0faf21198.jpg?ts=1749161099",
      "https://www.eago.de/media/6b/52/b7/1749161099/6d7ff607aeeef2c0c9a624c31bd2c09e.jpg?ts=1749161099",
      "https://www.eago.de/media/6f/a7/a9/1749161100/54ede34a92e310750a3088f6e47e7ae7.jpg?ts=1749161100",
      "https://www.eago.de/media/6f/30/26/1749161100/433cb49ed01c0f3da7d3f97f8c442a13.jpg?ts=1749161100",
      "https://www.eago.de/media/8d/b4/03/1749161101/fb850a461d85cd02ca62c6c54a20a7ac.jpg?ts=1749161101"
    ],
    "specs": {
      "Maße (innen)": "180 × 150 cm",
      "Außenmaße": "180 × 150 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16595"
    },
    "desc": [
      {
        "h": "Lieferumfang & Ausstattung",
        "items": [
          "8 mm ESG Sicherheitsglas",
          "Hochwertiges Hemlock Holz (Kanadische Hemlocktanne)",
          "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
          "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
          "Saunabänke & Holzboden",
          "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
          "9 kW Harvia Cilindro Saunaofen",
          "Thermometer, Sanduhr, Aufgusseimer + Kelle",
          "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
          "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
          "Eigenes Ersatzteillager & technischer Support"
        ]
      },
      {
        "h": "Der Saunaofen – Harvia Cilindro",
        "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
        "h": "Bedienfeld – Harvia Xenio",
        "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
        "h": "Alternative Steuerungen (optional)",
        "items": [
          "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
          "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
          "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
        ]
      },
      {
        "h": "Das Holz – Hemlock",
        "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
        "h": "Indirekte LED-Beleuchtung",
        "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
        "h": "Frischluftzufuhr & Klimasteuerung",
        "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
        "h": "Sonderanfertigungen",
        "text": "Anderer Ofen, spiegelverkehrter Aufbau oder abweichende Maße? Wir fertigen dieses Modell auf Wunsch individuell an. Einfach eine Zeichnung mit Wunschmaßen zusenden – wir erstellen ein persönliches Angebot."
      },
      {
        "h": "Sicherheitshinweise",
        "items": [
          "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
          "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
          "Kinder nur unter Aufsicht Erwachsener",
          "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
          "Elektroanschluss nur durch qualifizierten Fachbetrieb",
          "5–10 cm Abstand zu angrenzenden Wänden einhalten"
        ]
      }
    ]
  },
  {
    "handle": "e1103c-hemlock-120x105-6-8kw-cilindro",
    "title": "E1103C Hemlock 120x105 6.8kW Cilindro",
    "price": "3.699,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/82/37/3c/1749161163/4f0828e686c905fdeddc32ec7f88e54b.jpg?ts=1749161163",
    "bg_id": "16598",
    "imgs": [
      "https://www.eago.de/media/82/37/3c/1749161163/4f0828e686c905fdeddc32ec7f88e54b.jpg?ts=1749161163",
      "https://www.eago.de/media/fb/b4/62/1749161164/720c51f7907691fc14dfbb6eb416aa63.jpg?ts=1749161164",
      "https://www.eago.de/media/09/ed/00/1749161165/8bd24db59ee904dcf422e90394b4fa5e.jpg?ts=1749161165",
      "https://www.eago.de/media/f7/38/10/1749161165/915dab3ba8cad99e8e311681320c02c7.jpg?ts=1749161165",
      "https://www.eago.de/media/3e/ed/5b/1749161165/0b1f270e12929273e8f6b2d28d58d99e.jpg?ts=1749161165",
      "https://www.eago.de/media/eb/1b/bd/1749161166/e63b073165a10e8b727895b06cb023ee.jpg?ts=1749161166",
      "https://www.eago.de/media/1d/81/38/1749161166/2296fbe459a56c27c86b8d817f78312b.jpg?ts=1749161166"
    ],
    "specs": {
      "Maße (innen)": "120 × 105 cm",
      "Außenmaße": "120 × 105 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (Kompakt)",
      "Ofenleistung": "6.8 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "1–2 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16598"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "6.8 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1105c-hemlock-180x180-9kw-cilindro",
    "title": "E1105C Hemlock 180x180 9kW Cilindro",
    "price": "6.999,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/fa/4b/1e/1749161208/9a0fcd1cb2da367adfc161ec4b4bf54a.jpg?ts=1749161208",
    "bg_id": "16601",
    "imgs": [
      "https://www.eago.de/media/fa/4b/1e/1749161208/9a0fcd1cb2da367adfc161ec4b4bf54a.jpg?ts=1749161208",
      "https://www.eago.de/media/a8/37/26/1749161209/e863a8039210e100ff1a56327281137a.jpg?ts=1749161209",
      "https://www.eago.de/media/02/8c/03/1749161210/06db6f9643a2b88f6053bd65564b0622.jpg?ts=1749161210",
      "https://www.eago.de/media/68/d3/07/1749161210/ed719f5116d9287655a62e49120a09b1.jpg?ts=1749161210",
      "https://www.eago.de/media/70/ce/e0/1749161211/51da3367f24e80f42272f2a601abdba9.jpg?ts=1749161211",
      "https://www.eago.de/media/d6/34/5e/1749161211/9d9fb233c34e998a4d2ea9abed2dd0f4.jpg?ts=1749161211",
      "https://www.eago.de/media/cf/5a/0d/1749161211/55178efaad2d03ff00ae10e6b0ff3732.jpg?ts=1749161211"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16601"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "180.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1601c-hemlock-180x180-9kw-cilindro",
    "title": "E1601C Hemlock 180x180 9kW Cilindro",
    "price": "6.299,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/78/43/01/1750105211/bef14a5794171de79deab6f0df4fac4a.jpg?ts=1750105211",
    "bg_id": "16858",
    "imgs": [
      "https://www.eago.de/media/78/43/01/1750105211/bef14a5794171de79deab6f0df4fac4a.jpg?ts=1750105211",
      "https://www.eago.de/media/1f/ac/3f/1750105212/d3af046b4c508a7783a9e74f03412934.jpg?ts=1750105212",
      "https://www.eago.de/media/77/5e/f8/1750105213/1b224b1ecef5716ca947c7831591d3a6.jpg?ts=1750105213",
      "https://www.eago.de/media/1c/66/b6/1750105213/74d2966d06c430002dfe24309a172cd8.jpg?ts=1750105213",
      "https://www.eago.de/media/89/cc/a4/1750105213/35eb029f3c9a4ab5a341a62b3bc0add0.jpg?ts=1750105213",
      "https://www.eago.de/media/f9/36/2c/1750105213/020e75a78e3d7809a1eda01726b56bf2.jpg?ts=1750105213",
      "https://www.eago.de/media/4d/fd/ce/1750105214/c2256e49c5ba96d5899b2dd916869f75.jpg?ts=1750105214",
      "https://www.eago.de/media/24/1d/3a/1750105214/0de469d3215e6791b86c45d6e59909a6.jpg?ts=1750105214",
      "https://www.eago.de/media/2e/83/b2/1750105214/85a3a192167d2ae8cd245bc1159d8fad.jpg?ts=1750105214"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16858"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "180.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1602c-hemlock-180x160-9kw-cilindro",
    "title": "E1602C Hemlock 180x160 9kW Cilindro",
    "price": "6.199,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/7c/84/c7/1750191473/00838d99c864731a55b7abd417aa6d91.jpg?ts=1750191473",
    "bg_id": "16934",
    "imgs": [
      "https://www.eago.de/media/7c/84/c7/1750191473/00838d99c864731a55b7abd417aa6d91.jpg?ts=1750191473",
      "https://www.eago.de/media/71/ee/d1/1750191474/f3a64a1d36ca82595aaeb3888b3ba485.jpg?ts=1750191474",
      "https://www.eago.de/media/c0/c0/68/1750191474/1b212bb4836725152aab83131397d355.jpg?ts=1750191474",
      "https://www.eago.de/media/97/57/65/1750191475/04c0badad2b05b8a1dbec2d0ad7fd598.jpg?ts=1750191475",
      "https://www.eago.de/media/ae/74/72/1750191475/81ed294d5c61b0274617667012edc121.jpg?ts=1750191475",
      "https://www.eago.de/media/19/24/9b/1750191475/c6ce04ed21df3d2e8ce463fb93612f6c.jpg?ts=1750191475",
      "https://www.eago.de/media/2a/41/82/1750191475/83981c926434b4e3e932b3d46576a540.jpg?ts=1750191475",
      "https://www.eago.de/media/49/cd/c8/1750191476/cfdb97a18503fe93c5fcba0ee5ab3f95.jpg?ts=1750191476"
    ],
    "specs": {
      "Maße (innen)": "180 × 160 cm",
      "Außenmaße": "180 × 160 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "160.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16934"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "160.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1603c-hemlock-180x180-9kw-cilindro",
    "title": "E1603C Hemlock 180x180 9kW Cilindro",
    "price": "6.999,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/03/04/ea/1750191551/c8296576d2f99243545184ad8bcf8c70.jpg?ts=1750191551",
    "bg_id": "16981",
    "imgs": [
      "https://www.eago.de/media/03/04/ea/1750191551/c8296576d2f99243545184ad8bcf8c70.jpg?ts=1750191551",
      "https://www.eago.de/media/41/65/19/1750191552/f9135df96ca7818d7356b305f30e5117.jpg?ts=1750191552",
      "https://www.eago.de/media/09/1c/3e/1750191553/c587f975a734a175aab4a7ef81ec4f23.jpg?ts=1750191553",
      "https://www.eago.de/media/c1/f0/52/1750191553/3f6acb06e57219a752ab600fdf0f8740.jpg?ts=1750191553",
      "https://www.eago.de/media/4e/26/89/1750191553/5fbde889534dc7fdf5054f61bb17772f.jpg?ts=1750191553",
      "https://www.eago.de/media/3b/95/bf/1750191554/61e8d12d3b9923e36762dcd8e08065a4.jpg?ts=1750191554",
      "https://www.eago.de/media/45/6d/93/1750191554/6bb70bf1aa562052329a492ea6088e85.jpg?ts=1750191554",
      "https://www.eago.de/media/74/d8/55/1750191554/a32c15f157de4d62b23453e49d46027b.jpg?ts=1750191554",
      "https://www.eago.de/media/fd/ed/0e/1750191555/66f0648cba3450777990c44f2a21ce95.jpg?ts=1750191555",
      "https://www.eago.de/media/ba/33/3d/1750191555/b898fe3790d3cd27ff24565344debe00.jpg?ts=1750191555"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16981"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "180.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1604c-hemlock-160x150-6-8kw-cilindro",
    "title": "E1604C Hemlock 160x150 6.8kW Cilindro",
    "price": "5.699,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/6c/85/65/1750191657/01b98784582c45a81aa0bc6694d2babe.jpg?ts=1750191657",
    "bg_id": "17043",
    "imgs": [
      "https://www.eago.de/media/6c/85/65/1750191657/01b98784582c45a81aa0bc6694d2babe.jpg?ts=1750191657",
      "https://www.eago.de/media/2d/8a/d3/1750191658/00b38837c7d496106ac1bb8501724af5.jpg?ts=1750191658",
      "https://www.eago.de/media/6e/49/b8/1750191659/57b4113d5bc75f6ab2df094d15f896ed.jpg?ts=1750191659",
      "https://www.eago.de/media/c3/e2/47/1750191659/43132bd4b0842cc921d7de4509796201.jpg?ts=1750191659",
      "https://www.eago.de/media/df/3a/8e/1750191659/b9a500c45c9172e1131cc8a7b03a30f7.jpg?ts=1750191659",
      "https://www.eago.de/media/73/54/d6/1750191660/d524c07312181b7fa79f0aa267a2996e.jpg?ts=1750191660",
      "https://www.eago.de/media/20/88/61/1750191660/21150c777a50cea45aeb88f3aae478ea.jpg?ts=1750191660",
      "https://www.eago.de/media/e0/7b/04/1750191660/c13f7a621979679600571dc1c3b40ce7.jpg?ts=1750191660",
      "https://www.eago.de/media/de/07/7f/1750191661/b4b7666189909f43bd33bc93c924e679.jpg?ts=1750191661",
      "https://www.eago.de/media/1e/e5/8e/1750191661/0663de215c50e3fabd5e849c3ade29e4.jpg?ts=1750191661"
    ],
    "specs": {
      "Maße (innen)": "160 × 150 cm",
      "Außenmaße": "160 × 150 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (Kompakt)",
      "Ofenleistung": "6.8 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "1–2 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17043"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "6.8 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1111c-hemlock-180x180-9kw-cilindro",
    "title": "E1111C Hemlock 180x180 9kW Cilindro",
    "price": "5.399,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/c5/6a/9c/1749161310/6de008672cb10b97bbb684139cc27e71.jpg?ts=1749161310",
    "bg_id": "16613",
    "imgs": [
      "https://www.eago.de/media/c5/6a/9c/1749161310/6de008672cb10b97bbb684139cc27e71.jpg?ts=1749161310",
      "https://www.eago.de/media/d4/1d/fe/1749161311/871822517d46e8196c956eb9078d00b2.jpg?ts=1749161311",
      "https://www.eago.de/media/42/11/01/1749161311/12d6de27b930b215b3ca6b88e95a952b.jpg?ts=1749161311",
      "https://www.eago.de/media/69/46/f4/1749161312/f7f05de9d9a120c31bfe17b95024950b.jpg?ts=1749161312",
      "https://www.eago.de/media/04/0b/98/1749161312/016d371d3f0bdd103436a2aa19dbebbf.jpg?ts=1749161312",
      "https://www.eago.de/media/2e/fb/92/1749161312/52b7d12127827c56d679f81ffa1ef88d.jpg?ts=1749161312",
      "https://www.eago.de/media/5f/de/2b/1749161313/b09f9f8f4abd8c842301457d2137256e.jpg?ts=1749161313",
      "https://www.eago.de/media/f8/29/45/1749161313/0406aa926140d0c8013d1e584bfe5a5c.jpg?ts=1749161313",
      "https://www.eago.de/media/a4/2a/36/1749161313/65de825ded550faf271464a3330689da.jpg?ts=1749161313"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16606"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "180.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1112c-hemlock-180x150-9kw-cilindro",
    "title": "E1112C Hemlock 180x150 9kW Cilindro",
    "price": "5.499,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/df/99/9f/1749161351/757ebb78207843e14be04897561150e4.jpg?ts=1749161351",
    "bg_id": "16622",
    "imgs": [
      "https://www.eago.de/media/df/99/9f/1749161351/757ebb78207843e14be04897561150e4.jpg?ts=1749161351",
      "https://www.eago.de/media/4e/0f/dd/1749161352/5ad373802b131abb314cdaad357aa7d3.jpg?ts=1749161352",
      "https://www.eago.de/media/98/28/34/1749161353/55b6b2935bf62ba198114293df621052.jpg?ts=1749161353",
      "https://www.eago.de/media/f9/4a/42/1749161353/3b7359f5bad73cf421e660ce0eed4794.jpg?ts=1749161353",
      "https://www.eago.de/media/f4/b6/8e/1749161353/8a1f7fecfa3679d09788c18de0d577e3.jpg?ts=1749161353",
      "https://www.eago.de/media/88/9f/15/1749161354/315569cc7d4985ea62ed9fb637b3480a.jpg?ts=1749161354"
    ],
    "specs": {
      "Maße (innen)": "180 × 150 cm",
      "Außenmaße": "180 × 150 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "150.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16609"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "150.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1113c-hemlock-120x105-6-8kw-cilindro",
    "title": "E1113C Hemlock 120x105 6.8kW Cilindro",
    "price": "3.599,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/e6/46/fd/1749240759/0b47bc820b75150254435be25d155cda.jpg?ts=1749240759",
    "bg_id": "16631",
    "imgs": [
      "https://www.eago.de/media/e6/46/fd/1749240759/0b47bc820b75150254435be25d155cda.jpg?ts=1749240759",
      "https://www.eago.de/media/65/c2/3d/1749240760/84f2c4a62c0c2cbde304ed674ecbce81.jpg?ts=1749240760",
      "https://www.eago.de/media/63/84/69/1749240761/7a339e8905ede48168799076bba8b243.jpg?ts=1749240761",
      "https://www.eago.de/media/0a/02/8a/1749240761/9efdebd4e186ff9eb9ae6e86b88ff9eb.jpg?ts=1749240761",
      "https://www.eago.de/media/c6/3e/d0/1749240761/a58dbc30200f7f71b4d772a6d2e16ea4.jpg?ts=1749240761",
      "https://www.eago.de/media/a6/b6/6c/1749240762/ed7ccac9fd5fb8c4b68fcf16f1cee2e5.jpg?ts=1749240762"
    ],
    "specs": {
      "Maße (innen)": "120 × 105 cm",
      "Außenmaße": "120 × 105 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (Kompakt)",
      "Ofenleistung": "6.8 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "1–2 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16612"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "6.8 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1115c-hemlock-180x180-9kw-cilindro",
    "title": "E1115C Hemlock 180x180 9kW Cilindro",
    "price": "6.499,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/95/0e/6c/1749240791/5fc83d4ec60f7af00116d2b709af3b4b.jpg?ts=1749240791",
    "bg_id": "16640",
    "imgs": [
      "https://www.eago.de/media/95/0e/6c/1749240791/5fc83d4ec60f7af00116d2b709af3b4b.jpg?ts=1749240791",
      "https://www.eago.de/media/0c/6f/63/1749240792/4a2cead7789b34dbee8fc2c5c4f6f960.jpg?ts=1749240792",
      "https://www.eago.de/media/3d/de/d4/1749240792/52d3178a90deba615ebe8458785cdf8c.jpg?ts=1749240792",
      "https://www.eago.de/media/e1/80/7d/1749240793/f4b2b019d475fbf62f7cf71af48bdd91.jpg?ts=1749240793",
      "https://www.eago.de/media/ff/82/63/1749240793/af74e18af00e589daf77eb83b1482f0b.jpg?ts=1749240793",
      "https://www.eago.de/media/16/58/76/1749240793/0c74b5f3eaa74ee35715bfde6fa604e0.jpg?ts=1749240793",
      "https://www.eago.de/media/70/5c/31/1749240794/19ff18eb177b68ae8982be4d6e82f558.jpg?ts=1749240794"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16615"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "180.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1611c-hemlock-180x180-9kw-cilindro",
    "title": "E1611C Hemlock 180x180 9kW Cilindro",
    "price": "6.299,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/83/df/10/1750191754/bc9710d1b35da6230006c87460ccf6cc.jpg?ts=1750191754",
    "bg_id": "16912",
    "imgs": [
      "https://www.eago.de/media/83/df/10/1750191754/bc9710d1b35da6230006c87460ccf6cc.jpg?ts=1750191754",
      "https://www.eago.de/media/8d/ce/db/1750191756/5d47fdd6967e1832c9164d4fb4da5149.jpg?ts=1750191756",
      "https://www.eago.de/media/e0/1d/fd/1750191756/85d8b65667f7113b1c06e3db8f5f47bf.jpg?ts=1750191756",
      "https://www.eago.de/media/28/36/6a/1750191756/c225e102648ff102bcc98013754aabf4.jpg?ts=1750191756",
      "https://www.eago.de/media/bd/b6/96/1750191757/cf6711b9f155c1c56f6f63e731c77401.jpg?ts=1750191757",
      "https://www.eago.de/media/ba/37/ec/1750191757/bf95d93e42fabd64a57eae963af917f1.jpg?ts=1750191757",
      "https://www.eago.de/media/4a/53/89/1750191757/bf032356ffa9754b75c41d0776cec9b1.jpg?ts=1750191757",
      "https://www.eago.de/media/07/62/3e/1750191758/5b3c8156f3a6ede09f9136b27a31d4fc.jpg?ts=1750191758",
      "https://www.eago.de/media/2a/9e/ba/1750191758/50fda4984148f0d59d06b8b0db1772a0.jpg?ts=1750191758"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16912"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "180.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1612c-hemlock-180x160-9kw-cilindro",
    "title": "E1612C Hemlock 180x160 9kW Cilindro",
    "price": "5.999,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/a7/9e/87/1759311632/f91cd633bcf4bd1ca9d044727c36687b.jpg?ts=1759311632",
    "bg_id": "16943",
    "imgs": [
      "https://www.eago.de/media/a7/9e/87/1759311632/f91cd633bcf4bd1ca9d044727c36687b.jpg?ts=1759311632",
      "https://www.eago.de/media/ab/5b/5d/1759311634/7ab64834a27a277b119a6c1f67ed7932.jpg?ts=1759311634",
      "https://www.eago.de/media/bb/d1/79/1759311634/6db518740c63704269ed7b642fd8aa49.jpg?ts=1759311634",
      "https://www.eago.de/media/2a/b3/85/1759311634/e14398195d52a134a98d866594d69172.jpg?ts=1759311634",
      "https://www.eago.de/media/e7/a2/3d/1759311635/4c75da28e9ba5a183b42a3690c27ea59.jpg?ts=1759311635",
      "https://www.eago.de/media/aa/82/af/1759311635/a0089a376626ec7e5f8d31700057b26c.jpg?ts=1759311635",
      "https://www.eago.de/media/4b/ac/31/1759311635/013b810f829e9953f4b76303a2243379.jpg?ts=1759311635",
      "https://www.eago.de/media/47/8b/37/1759311636/4d81b91893f8b652453f3619720f0601.jpg?ts=1759311636",
      "https://www.eago.de/media/65/5e/5f/1759311636/b1b48d75e8119d461b20be04f5fb4e45.jpg?ts=1759311636",
      "https://www.eago.de/media/7e/4f/76/1759311636/bb44c6651fd3415c13e8434fd8325f1f.jpg?ts=1759311636"
    ],
    "specs": {
      "Maße (innen)": "180 × 160 cm",
      "Außenmaße": "180 × 160 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "160.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16937"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "160.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1613c-hemlock-180x180-9kw-cilindro",
    "title": "E1613C Hemlock 180x180 9kW Cilindro",
    "price": "6.699,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/03/04/ea/1750191551/c8296576d2f99243545184ad8bcf8c70.jpg?ts=1750191551",
    "bg_id": "17000",
    "imgs": [
      "https://www.eago.de/media/03/04/ea/1750191551/c8296576d2f99243545184ad8bcf8c70.jpg?ts=1750191551",
      "https://www.eago.de/media/41/65/19/1750191552/f9135df96ca7818d7356b305f30e5117.jpg?ts=1750191552",
      "https://www.eago.de/media/09/1c/3e/1750191553/c587f975a734a175aab4a7ef81ec4f23.jpg?ts=1750191553",
      "https://www.eago.de/media/c1/f0/52/1750191553/3f6acb06e57219a752ab600fdf0f8740.jpg?ts=1750191553",
      "https://www.eago.de/media/4e/26/89/1750191553/5fbde889534dc7fdf5054f61bb17772f.jpg?ts=1750191553",
      "https://www.eago.de/media/3b/95/bf/1750191554/61e8d12d3b9923e36762dcd8e08065a4.jpg?ts=1750191554",
      "https://www.eago.de/media/45/6d/93/1750191554/6bb70bf1aa562052329a492ea6088e85.jpg?ts=1750191554",
      "https://www.eago.de/media/74/d8/55/1750191554/a32c15f157de4d62b23453e49d46027b.jpg?ts=1750191554",
      "https://www.eago.de/media/fd/ed/0e/1750191555/66f0648cba3450777990c44f2a21ce95.jpg?ts=1750191555",
      "https://www.eago.de/media/ba/33/3d/1750191555/b898fe3790d3cd27ff24565344debe00.jpg?ts=1750191555"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16984"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "180.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1614c-hemlock-160x150-6-8kw-cilindro",
    "title": "E1614C Hemlock 160x150 6.8kW Cilindro",
    "price": "5.699,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/87/a1/af/1750277768/7c0db5303b024bcd194c3b26def0c9a2.jpg?ts=1750277768",
    "bg_id": "17052",
    "imgs": [
      "https://www.eago.de/media/87/a1/af/1750277768/7c0db5303b024bcd194c3b26def0c9a2.jpg?ts=1750277768",
      "https://www.eago.de/media/17/2a/59/1750277769/e051eb1f556e3e61da64451e3d082a82.jpg?ts=1750277769",
      "https://www.eago.de/media/ca/b6/c3/1750277770/ddab6b44355dc126029dae5ac631a86a.jpg?ts=1750277770",
      "https://www.eago.de/media/9a/b1/e1/1750277770/3d1a1d577b08fd1ff6e64fb38c83dff6.jpg?ts=1750277770",
      "https://www.eago.de/media/bb/9e/fe/1750277770/b8e45e40e0adc17ebd1665b76b6da8ab.jpg?ts=1750277770",
      "https://www.eago.de/media/78/e5/a3/1750277771/a9baf43c6a90151350543645106028a8.jpg?ts=1750277771",
      "https://www.eago.de/media/28/99/db/1750277771/1121d7397cb85a3468728666bb92117e.jpg?ts=1750277771",
      "https://www.eago.de/media/46/e6/01/1750277771/f52cf2d886b4ad0d0ca0a7dc4b829abc.jpg?ts=1750277771",
      "https://www.eago.de/media/22/50/69/1750277772/5b64e958ec8236f94d8ce5af81135703.jpg?ts=1750277772"
    ],
    "specs": {
      "Maße (innen)": "160 × 150 cm",
      "Außenmaße": "160 × 150 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (Kompakt)",
      "Ofenleistung": "6.8 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "1–2 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17046"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "6.8 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1621c-hemlock-180x180-9kw-cilindro",
    "title": "E1621C Hemlock 180x180 9kW Cilindro",
    "price": "6.299,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/0e/7c/23/1750277840/b18468f7bf4b83b1a2c37fefe2cc36fb.jpg?ts=1750277840",
    "bg_id": "16872",
    "imgs": [
      "https://www.eago.de/media/0e/7c/23/1750277840/b18468f7bf4b83b1a2c37fefe2cc36fb.jpg?ts=1750277840",
      "https://www.eago.de/media/a6/88/68/1750277841/8d0fe03bb0b762e94ae80e106658bc1c.jpg?ts=1750277841",
      "https://www.eago.de/media/ae/f9/a3/1750277841/1d00f3422955b35c5877d61099e03b57.jpg?ts=1750277841",
      "https://www.eago.de/media/b5/81/c6/1750277842/28cbab23f3a1b6f23b3a77e92164fec6.jpg?ts=1750277842",
      "https://www.eago.de/media/5a/d9/59/1750277842/cc37b98e00b7ad665c8ecc0e832b66a7.jpg?ts=1750277842",
      "https://www.eago.de/media/39/03/bc/1750277842/f81add8b0da8a19a06df39252d710ce2.jpg?ts=1750277842",
      "https://www.eago.de/media/54/53/b2/1750277843/9959cdd611d41cd2e00cc4fd6271aa41.jpg?ts=1750277843"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16915"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "180.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1622c-hemlock-180x160-9kw-cilindro",
    "title": "E1622C Hemlock 180x160 9kW Cilindro",
    "price": "6.199,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/a7/9e/87/1759311632/f91cd633bcf4bd1ca9d044727c36687b.jpg?ts=1759311632",
    "bg_id": "16957",
    "imgs": [
      "https://www.eago.de/media/a7/9e/87/1759311632/f91cd633bcf4bd1ca9d044727c36687b.jpg?ts=1759311632",
      "https://www.eago.de/media/ab/5b/5d/1759311634/7ab64834a27a277b119a6c1f67ed7932.jpg?ts=1759311634",
      "https://www.eago.de/media/bb/d1/79/1759311634/6db518740c63704269ed7b642fd8aa49.jpg?ts=1759311634",
      "https://www.eago.de/media/2a/b3/85/1759311634/e14398195d52a134a98d866594d69172.jpg?ts=1759311634",
      "https://www.eago.de/media/e7/a2/3d/1759311635/4c75da28e9ba5a183b42a3690c27ea59.jpg?ts=1759311635",
      "https://www.eago.de/media/aa/82/af/1759311635/a0089a376626ec7e5f8d31700057b26c.jpg?ts=1759311635",
      "https://www.eago.de/media/4b/ac/31/1759311635/013b810f829e9953f4b76303a2243379.jpg?ts=1759311635",
      "https://www.eago.de/media/47/8b/37/1759311636/4d81b91893f8b652453f3619720f0601.jpg?ts=1759311636",
      "https://www.eago.de/media/65/5e/5f/1759311636/b1b48d75e8119d461b20be04f5fb4e45.jpg?ts=1759311636",
      "https://www.eago.de/media/7e/4f/76/1759311636/bb44c6651fd3415c13e8434fd8325f1f.jpg?ts=1759311636"
    ],
    "specs": {
      "Maße (innen)": "180 × 160 cm",
      "Außenmaße": "180 × 160 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "160.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16940"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "160.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1623c-hemlock-180x180-9kw-cilindro",
    "title": "E1623C Hemlock 180x180 9kW Cilindro",
    "price": "6.999,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/03/04/ea/1750191551/c8296576d2f99243545184ad8bcf8c70.jpg?ts=1750191551",
    "bg_id": "17015",
    "imgs": [
      "https://www.eago.de/media/03/04/ea/1750191551/c8296576d2f99243545184ad8bcf8c70.jpg?ts=1750191551",
      "https://www.eago.de/media/41/65/19/1750191552/f9135df96ca7818d7356b305f30e5117.jpg?ts=1750191552",
      "https://www.eago.de/media/09/1c/3e/1750191553/c587f975a734a175aab4a7ef81ec4f23.jpg?ts=1750191553",
      "https://www.eago.de/media/c1/f0/52/1750191553/3f6acb06e57219a752ab600fdf0f8740.jpg?ts=1750191553",
      "https://www.eago.de/media/4e/26/89/1750191553/5fbde889534dc7fdf5054f61bb17772f.jpg?ts=1750191553",
      "https://www.eago.de/media/3b/95/bf/1750191554/61e8d12d3b9923e36762dcd8e08065a4.jpg?ts=1750191554",
      "https://www.eago.de/media/45/6d/93/1750191554/6bb70bf1aa562052329a492ea6088e85.jpg?ts=1750191554",
      "https://www.eago.de/media/74/d8/55/1750191554/a32c15f157de4d62b23453e49d46027b.jpg?ts=1750191554",
      "https://www.eago.de/media/fd/ed/0e/1750191555/66f0648cba3450777990c44f2a21ce95.jpg?ts=1750191555",
      "https://www.eago.de/media/ba/33/3d/1750191555/b898fe3790d3cd27ff24565344debe00.jpg?ts=1750191555"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16987"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "180.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1624c-hemlock-160x150-6-8kw-cilindro",
    "title": "E1624C Hemlock 160x150 6.8kW Cilindro",
    "price": "5.699,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/82/77/01/1750277979/3db7cc3cb5471c3accd7b97812fdea51.jpg?ts=1750277979",
    "bg_id": "17061",
    "imgs": [
      "https://www.eago.de/media/82/77/01/1750277979/3db7cc3cb5471c3accd7b97812fdea51.jpg?ts=1750277979",
      "https://www.eago.de/media/8f/c9/86/1750277981/07fe6bb81159fd426c51da873463603d.jpg?ts=1750277981",
      "https://www.eago.de/media/96/5a/ff/1750277981/a16f48a852e1cc0e5db82c177b5e4d95.jpg?ts=1750277981",
      "https://www.eago.de/media/e3/90/9a/1750277981/0b4cd73590e8276227f351c29b56aa99.jpg?ts=1750277981",
      "https://www.eago.de/media/08/d7/af/1750277982/9ea2548ec621ec64e899b96f60e6c4a3.jpg?ts=1750277982",
      "https://www.eago.de/media/a8/98/eb/1750277982/2b71ee300667aa96ead08e54e05f522c.jpg?ts=1750277982",
      "https://www.eago.de/media/e3/17/a5/1750277982/5bfb7e38475908cf3d500f1d03186a26.jpg?ts=1750277982",
      "https://www.eago.de/media/98/28/4a/1750277983/a5ab12493b05d892679e172d8912a1a9.jpg?ts=1750277983"
    ],
    "specs": {
      "Maße (innen)": "160 × 150 cm",
      "Außenmaße": "160 × 150 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (Kompakt)",
      "Ofenleistung": "6.8 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "1–2 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17049"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "6.8 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1600c-hemlock-300x250-13-5kw-virta",
    "title": "E1600C Hemlock 300x250 13.5kW Virta",
    "price": "14.499,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/09/45/09/1750105152/5ffb646843f4787f9ad9b9769c72688a.jpg?ts=1750105152",
    "bg_id": "16842",
    "imgs": [
      "https://www.eago.de/media/09/45/09/1750105152/5ffb646843f4787f9ad9b9769c72688a.jpg?ts=1750105152",
      "https://www.eago.de/media/ba/e5/de/1750105153/a65a059a02107314834ccc31e76b371d.jpg?ts=1750105153",
      "https://www.eago.de/media/f7/f3/e9/1750105153/feaacbdd195e9b9677c4b153ccd36061.jpg?ts=1750105153",
      "https://www.eago.de/media/a9/e4/5e/1750105154/b5c7f0bf95206e1f2d60b7a202f64a1b.jpg?ts=1750105154",
      "https://www.eago.de/media/82/5a/da/1750105154/86eb9d5e0b620ab55f9f1b6feeabe1ce.jpg?ts=1750105154",
      "https://www.eago.de/media/b3/6e/dd/1750105154/ac1ec62f4a81f47dac4a830b97a0e06b.jpg?ts=1750105154",
      "https://www.eago.de/media/66/d1/a2/1750105155/f1f6e0650decc2f26b463a67478fc716.jpg?ts=1750105155",
      "https://www.eago.de/media/9f/38/7b/1750105155/9239969c8906dc9aa43f031529a26b6f.jpg?ts=1750105155",
      "https://www.eago.de/media/28/c6/d2/1750105155/309e3211b492648faeff6737c97b8433.jpg?ts=1750105155",
      "https://www.eago.de/media/c7/5a/c2/1750105155/d9a9017483c40903cc05dde22645b06d.jpg?ts=1750105155"
    ],
    "specs": {
      "Maße (innen)": "300 × 250 cm",
      "Außenmaße": "300 × 250 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Infrarotkabine + Finnische Sauna",
      "Ofenleistung": "13.5 kW",
      "Ofen": "Harvia Virta – Hochleistungs-Saunaofen für große Kabinen",
      "Bedienfeld": "Harvia Xenio Combi (opt.: Griffin App-Steuerung)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "38 mm Profilholz",
      "Infrarotstrahler": "6× Vollspektrum-Karbon-Strahler",
      "IR-Leistung": "2.800 W gesamt",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16861"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Hemlock-Holz",
                  "6× Vollspektrum-Karbon-Infrarotstrahler (2.800 W gesamt)",
                  "Digitales Bedienfeld mit Timer und Temperaturregelung",
                  "Saunabänke & Holzboden",
                  "LED-Innenbeleuchtung",
                  "13.5 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld",
                  "Klimasteuerung & Frischluftzufuhr",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Virta",
            "text": "Der Harvia Virta ist der ideale Ofen für große Saunakabinen ab 300 × 250 cm. Mit 13.5 kW Leistung heizt er selbst großzügige Räume auf Wohlfühltemperatur auf. Die elegante Edelstahloptik und die großzügige Steinkapazität machen ihn zu einem echten Kraftpaket."
      },
      {
            "h": "Bedienfeld – Harvia Xenio Combi",
            "text": "Das Xenio Combi steuert Ofen und Beleuchtung komfortabel aus einer Einheit. Betriebszeit und Temperatur gradgenau einstellbar. Vorprogrammieren möglich – Sauna startet vollautomatisch zur gewünschten Zeit. Optional mit WIFI-Modul nachrüstbar."
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Infrarotstrahler & Wärmewirkung",
            "text": "Die 6 Vollspektrum-Karbon-Strahler erzeugen sanfte Wärme, die tief ins Gewebe eindringt. Infrarotlicht wirkt muskelentspannend, fördert die Durchblutung und hilft beim Abbau von Stresshormonen. Ideal als Ergänzung zur finnischen Sauna oder als eigenständige Wellness-Anwendung."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1620c-hemlock-300x250-13-5kw-virta",
    "title": "E1620C Hemlock 300x250 13.5kW Virta",
    "price": "14.499,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/8f/78/90/1750277808/a58a1509a0ae4ddeb7ee8f33ac677f92.jpg?ts=1750277808",
    "bg_id": "16902",
    "imgs": [
      "https://www.eago.de/media/8f/78/90/1750277808/a58a1509a0ae4ddeb7ee8f33ac677f92.jpg?ts=1750277808",
      "https://www.eago.de/media/8a/81/5f/1750277810/9d162448a45e4d922d85d8f7761bb33c.jpg?ts=1750277810",
      "https://www.eago.de/media/9b/29/07/1750277810/9ae0e22f71601565b56d3e1ce8174380.jpg?ts=1750277810",
      "https://www.eago.de/media/82/f7/67/1750277810/4ff08f0d0c4406626303de42101c19f7.jpg?ts=1750277810",
      "https://www.eago.de/media/31/e7/6c/1750277811/1ba373d31b4079af614767976cdce0b1.jpg?ts=1750277811",
      "https://www.eago.de/media/14/13/ba/1750277811/10a586b8b3b4e705048d7075708918d1.jpg?ts=1750277811",
      "https://www.eago.de/media/ea/e8/aa/1750277811/915a37480f401aa9951f1a8e0802d626.jpg?ts=1750277811",
      "https://www.eago.de/media/ba/fd/30/1750277812/430bf86765a7fdc8f49f2e3f61330572.jpg?ts=1750277812",
      "https://www.eago.de/media/77/7c/66/1750277812/659b76dc0cf2ed560d5b8138892cd738.jpg?ts=1750277812",
      "https://www.eago.de/media/5e/a6/97/1750277812/db3ca447feb97fdf9201cbd1c49ab2b6.jpg?ts=1750277812"
    ],
    "specs": {
      "Maße (innen)": "300 × 250 cm",
      "Außenmaße": "300 × 250 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Infrarotkabine + Finnische Sauna",
      "Ofenleistung": "13.5 kW",
      "Ofen": "Harvia Virta – Hochleistungs-Saunaofen für große Kabinen",
      "Bedienfeld": "Harvia Xenio Combi (opt.: Griffin App-Steuerung)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "38 mm Profilholz",
      "Infrarotstrahler": "6× Vollspektrum-Karbon-Strahler",
      "IR-Leistung": "2.800 W gesamt",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16918"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Hemlock-Holz",
                  "6× Vollspektrum-Karbon-Infrarotstrahler (2.800 W gesamt)",
                  "Digitales Bedienfeld mit Timer und Temperaturregelung",
                  "Saunabänke & Holzboden",
                  "LED-Innenbeleuchtung",
                  "13.5 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld",
                  "Klimasteuerung & Frischluftzufuhr",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Virta",
            "text": "Der Harvia Virta ist der ideale Ofen für große Saunakabinen ab 300 × 250 cm. Mit 13.5 kW Leistung heizt er selbst großzügige Räume auf Wohlfühltemperatur auf. Die elegante Edelstahloptik und die großzügige Steinkapazität machen ihn zu einem echten Kraftpaket."
      },
      {
            "h": "Bedienfeld – Harvia Xenio Combi",
            "text": "Das Xenio Combi steuert Ofen und Beleuchtung komfortabel aus einer Einheit. Betriebszeit und Temperatur gradgenau einstellbar. Vorprogrammieren möglich – Sauna startet vollautomatisch zur gewünschten Zeit. Optional mit WIFI-Modul nachrüstbar."
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Infrarotstrahler & Wärmewirkung",
            "text": "Die 6 Vollspektrum-Karbon-Strahler erzeugen sanfte Wärme, die tief ins Gewebe eindringt. Infrarotlicht wirkt muskelentspannend, fördert die Durchblutung und hilft beim Abbau von Stresshormonen. Ideal als Ergänzung zur finnischen Sauna oder als eigenständige Wellness-Anwendung."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1106b-hemlock-180x120-6-8kw-cilindro",
    "title": "E1106B Hemlock 180x120 6.8kW Cilindro",
    "price": "5.899,00 €",
    "cat": "Hemlock",
    "img": "https://www.eago.de/media/fc/0b/12/1749161250/a3cf352ce56e4dd5d92bd31de913e431.jpg?ts=1749161250",
    "bg_id": "16699",
    "imgs": [
      "https://www.eago.de/media/fc/0b/12/1749161250/a3cf352ce56e4dd5d92bd31de913e431.jpg?ts=1749161250",
      "https://www.eago.de/media/97/08/3a/1749161252/aa70b1ba598711d77697351aff2425f8.jpg?ts=1749161252",
      "https://www.eago.de/media/f3/e5/7a/1749161252/595cc84d8781061c3e39b1e6e5b158ea.jpg?ts=1749161252",
      "https://www.eago.de/media/13/c3/2c/1749161253/8b031ae7f69b67ccff16c61e0b74741c.jpg?ts=1749161253",
      "https://www.eago.de/media/ec/3a/20/1749161253/a5dfd7a2000934e7a8f0324956f5eae4.jpg?ts=1749161253",
      "https://www.eago.de/media/15/05/35/1749161253/4b9ca72abc4c90b7823ec3ea00fa2d3a.jpg?ts=1749161253",
      "https://www.eago.de/media/2f/fe/14/1749161254/61f782c003b6f278ce97f62e2e172905.jpg?ts=1749161254",
      "https://www.eago.de/media/78/69/c1/1749161254/005b8b2eaacd0850e83421d24d9b0084.jpg?ts=1749161254"
    ],
    "specs": {
      "Maße (innen)": "180 × 120 cm",
      "Außenmaße": "180 × 120 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "6.8 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16604"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Hemlock-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "6.8 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1201a-ir-pappelholz-236x236-9kw-cilindro",
    "title": "E1201A-IR Pappelholz 236x236 9kW Cilindro",
    "price": "8.799,00 €",
    "cat": "Pappelholz",
    "img": "https://www.eago.de/media/db/74/41/1749240804/17c3a2a9e241c55f2106324b4b826eed.jpg?ts=1749240804",
    "bg_id": "14749",
    "imgs": [
      "https://www.eago.de/media/db/74/41/1749240804/17c3a2a9e241c55f2106324b4b826eed.jpg?ts=1749240804",
      "https://www.eago.de/media/d9/a7/dc/1749240805/75cf8d9f5f70c1276a68d1933c7072fb.jpg?ts=1749240805",
      "https://www.eago.de/media/3f/31/8c/1749240805/d4d0ca77938772cf9554027e73c1933e.jpg?ts=1749240805",
      "https://www.eago.de/media/1b/03/dd/1749240806/a94899d16d271e598599ee0f6a57403c.jpg?ts=1749240806"
    ],
    "specs": {
      "Maße (innen)": "236 × 236 cm",
      "Außenmaße": "236 × 236 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Infrarotkabine + Finnische Sauna",
      "Ofenleistung": "236.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Pappelholz – Weiches Holz, ideal für Infrarotkabinen",
      "Wandaufbau": "38 mm Profilholz",
      "Infrarotstrahler": "6× Vollspektrum-Karbon-Strahler",
      "IR-Leistung": "2.800 W gesamt",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16618"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pappelholz-Holz",
                  "6× Vollspektrum-Karbon-Infrarotstrahler (2.800 W gesamt)",
                  "Digitales Bedienfeld mit Timer und Temperaturregelung",
                  "Saunabänke & Holzboden",
                  "LED-Innenbeleuchtung",
                  "236.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld",
                  "Klimasteuerung & Frischluftzufuhr",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Das Holz – Pappelholz",
            "text": "Pappelholz ist das klassische Material für Infrarotkabinen: geringe Wärmeabgabe, keine Splitter, glatte Oberfläche. Das helle, homogene Holz ist besonders körperverträglich – ideal für entspannte Infrarotbäder."
      },
      {
            "h": "Infrarotstrahler & Wärmewirkung",
            "text": "Die 6 Vollspektrum-Karbon-Strahler erzeugen sanfte Wärme, die tief ins Gewebe eindringt. Infrarotlicht wirkt muskelentspannend, fördert die Durchblutung und hilft beim Abbau von Stresshormonen. Ideal als Ergänzung zur finnischen Sauna oder als eigenständige Wellness-Anwendung."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1205a-ir-pappelholz-266x198-9kw-cilindro",
    "title": "E1205A-IR Pappelholz 266x198 9kW Cilindro",
    "price": "8.499,00 €",
    "cat": "Pappelholz",
    "img": "https://www.eago.de/media/ac/d5/c9/1749240809/37b409ac00d08194d524138983aa678d.jpg?ts=1749240809",
    "bg_id": "14763",
    "imgs": [
      "https://www.eago.de/media/ac/d5/c9/1749240809/37b409ac00d08194d524138983aa678d.jpg?ts=1749240809",
      "https://www.eago.de/media/d4/5c/10/1749240811/fb4a312cc75ef696908c401d0cba224a.jpg?ts=1749240811",
      "https://www.eago.de/media/1f/ab/cd/1749240811/f8d6b0740515b9e2a62bdbcd1a9c4703.jpg?ts=1749240811",
      "https://www.eago.de/media/bc/27/60/1749240811/57e812e8f73f5f0ed9c050d1e84405d4.jpg?ts=1749240811",
      "https://www.eago.de/media/db/74/41/1749240804/17c3a2a9e241c55f2106324b4b826eed.jpg?ts=1749240804",
      "https://www.eago.de/media/d9/a7/dc/1749240805/75cf8d9f5f70c1276a68d1933c7072fb.jpg?ts=1749240805",
      "https://www.eago.de/media/3f/31/8c/1749240805/d4d0ca77938772cf9554027e73c1933e.jpg?ts=1749240805",
      "https://www.eago.de/media/1b/03/dd/1749240806/a94899d16d271e598599ee0f6a57403c.jpg?ts=1749240806"
    ],
    "specs": {
      "Maße (innen)": "266 × 198 cm",
      "Außenmaße": "266 × 198 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Infrarotkabine + Finnische Sauna",
      "Ofenleistung": "198.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Pappelholz – Weiches Holz, ideal für Infrarotkabinen",
      "Wandaufbau": "38 mm Profilholz",
      "Infrarotstrahler": "6× Vollspektrum-Karbon-Strahler",
      "IR-Leistung": "2.800 W gesamt",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16624"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pappelholz-Holz",
                  "6× Vollspektrum-Karbon-Infrarotstrahler (2.800 W gesamt)",
                  "Digitales Bedienfeld mit Timer und Temperaturregelung",
                  "Saunabänke & Holzboden",
                  "LED-Innenbeleuchtung",
                  "198.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld",
                  "Klimasteuerung & Frischluftzufuhr",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Das Holz – Pappelholz",
            "text": "Pappelholz ist das klassische Material für Infrarotkabinen: geringe Wärmeabgabe, keine Splitter, glatte Oberfläche. Das helle, homogene Holz ist besonders körperverträglich – ideal für entspannte Infrarotbäder."
      },
      {
            "h": "Infrarotstrahler & Wärmewirkung",
            "text": "Die 6 Vollspektrum-Karbon-Strahler erzeugen sanfte Wärme, die tief ins Gewebe eindringt. Infrarotlicht wirkt muskelentspannend, fördert die Durchblutung und hilft beim Abbau von Stresshormonen. Ideal als Ergänzung zur finnischen Sauna oder als eigenständige Wellness-Anwendung."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1203b-ir-pappelholz-202x103-6-8kw-cilindro",
    "title": "E1203B-IR Pappelholz 202x103 6.8kW Cilindro",
    "price": "5.999,00 €",
    "cat": "Pappelholz",
    "img": "https://www.eago.de/media/ac/d5/c9/1749240809/37b409ac00d08194d524138983aa678d.jpg?ts=1749240809",
    "bg_id": "14663",
    "imgs": [
      "https://www.eago.de/media/ac/d5/c9/1749240809/37b409ac00d08194d524138983aa678d.jpg?ts=1749240809",
      "https://www.eago.de/media/d4/5c/10/1749240811/fb4a312cc75ef696908c401d0cba224a.jpg?ts=1749240811",
      "https://www.eago.de/media/1f/ab/cd/1749240811/f8d6b0740515b9e2a62bdbcd1a9c4703.jpg?ts=1749240811",
      "https://www.eago.de/media/bc/27/60/1749240811/57e812e8f73f5f0ed9c050d1e84405d4.jpg?ts=1749240811",
      "https://www.eago.de/media/db/74/41/1749240804/17c3a2a9e241c55f2106324b4b826eed.jpg?ts=1749240804",
      "https://www.eago.de/media/d9/a7/dc/1749240805/75cf8d9f5f70c1276a68d1933c7072fb.jpg?ts=1749240805",
      "https://www.eago.de/media/3f/31/8c/1749240805/d4d0ca77938772cf9554027e73c1933e.jpg?ts=1749240805",
      "https://www.eago.de/media/1b/03/dd/1749240806/a94899d16d271e598599ee0f6a57403c.jpg?ts=1749240806"
    ],
    "specs": {
      "Maße (innen)": "202 × 103 cm",
      "Außenmaße": "202 × 103 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Infrarotkabine + Finnische Sauna",
      "Ofenleistung": "6.8 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Pappelholz – Weiches Holz, ideal für Infrarotkabinen",
      "Wandaufbau": "38 mm Profilholz",
      "Infrarotstrahler": "6× Vollspektrum-Karbon-Strahler",
      "IR-Leistung": "2.800 W gesamt",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16621"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pappelholz-Holz",
                  "6× Vollspektrum-Karbon-Infrarotstrahler (2.800 W gesamt)",
                  "Digitales Bedienfeld mit Timer und Temperaturregelung",
                  "Saunabänke & Holzboden",
                  "LED-Innenbeleuchtung",
                  "6.8 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld",
                  "Klimasteuerung & Frischluftzufuhr",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Das Holz – Pappelholz",
            "text": "Pappelholz ist das klassische Material für Infrarotkabinen: geringe Wärmeabgabe, keine Splitter, glatte Oberfläche. Das helle, homogene Holz ist besonders körperverträglich – ideal für entspannte Infrarotbäder."
      },
      {
            "h": "Infrarotstrahler & Wärmewirkung",
            "text": "Die 6 Vollspektrum-Karbon-Strahler erzeugen sanfte Wärme, die tief ins Gewebe eindringt. Infrarotlicht wirkt muskelentspannend, fördert die Durchblutung und hilft beim Abbau von Stresshormonen. Ideal als Ergänzung zur finnischen Sauna oder als eigenständige Wellness-Anwendung."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1601c-rote-zeder-180x180-9kw-cilindro",
    "title": "E1601C rote Zeder 180x180 9kW Cilindro",
    "price": "8.799,00 €",
    "cat": "Zeder",
    "img": "https://www.eago.de/media/00/db/8f/1750105224/43f583f74be2949a71402a22591fab34.jpg?ts=1750105224",
    "bg_id": "16890",
    "imgs": [
      "https://www.eago.de/media/00/db/8f/1750105224/43f583f74be2949a71402a22591fab34.jpg?ts=1750105224",
      "https://www.eago.de/media/93/d0/e0/1750105225/10fbed4105a1f1976148a0de8cea7cc6.jpg?ts=1750105225",
      "https://www.eago.de/media/19/38/ec/1750105226/0d7b07c19d7cad04017925d0379d4dc1.jpg?ts=1750105226",
      "https://www.eago.de/media/5b/fb/24/1750105226/868696066d49ce63d1d596f4b477cc59.jpg?ts=1750105226",
      "https://www.eago.de/media/ac/62/bf/1750105226/5e6649ae14b69b006add5f4729b5b759.jpg?ts=1750105226",
      "https://www.eago.de/media/44/ea/8d/1750105227/0964cd2df3a9ae25004ce18ccf40ca54.jpg?ts=1750105227",
      "https://www.eago.de/media/62/8c/d2/1750105227/1f1615e0a4f4906019547ca6d47a1c44.jpg?ts=1750105227",
      "https://www.eago.de/media/56/0e/4a/1750105227/5df4266e7e2342498ae9c3c6c25c4c5b.jpg?ts=1750105227",
      "https://www.eago.de/media/a0/36/c5/1750105228/68aec410bc27f0ba7256ef4cfd378f9d.jpg?ts=1750105228",
      "https://www.eago.de/media/5b/b3/4a/1750105228/3f658ccdd1c2827513912e72b7ca9dd8.jpg?ts=1750105228"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Rote Zeder – Westliche Rotzeder, natürlich duftig",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16864"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Rote Zeder-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "180.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Rote Zeder",
            "text": "Rote Zeder (Western Red Cedar) aus Kanada ist seit Jahrzehnten das traditionelle Saunaholz für Premiumkabinen. Das Holz reguliert Feuchtigkeit natürlich, schwindet minimal und duftet angenehm holzig. Die warmen Rottöne sorgen für eine einzigartige Atmosphäre."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1602c-rote-zeder-180x160-9kw-cilindro",
    "title": "E1602C rote Zeder 180x160 9kW Cilindro",
    "price": "8.699,00 €",
    "cat": "Zeder",
    "img": "https://www.eago.de/media/86/2b/1b/1750191485/8b1674e01e376efb96e0a2ee0df4ea51.jpg?ts=1750191485",
    "bg_id": "16968",
    "imgs": [
      "https://www.eago.de/media/86/2b/1b/1750191485/8b1674e01e376efb96e0a2ee0df4ea51.jpg?ts=1750191485",
      "https://www.eago.de/media/5f/c5/5e/1750191487/e5566a3c5b856f4fc5f885a4eaf0d532.jpg?ts=1750191487",
      "https://www.eago.de/media/80/44/a0/1750191487/6ed9a2691d2e309b35df5df29149e7a7.jpg?ts=1750191487",
      "https://www.eago.de/media/30/1f/51/1750191487/44b6edae647307326cab2663291480a7.jpg?ts=1750191487",
      "https://www.eago.de/media/e3/53/87/1750191488/0d8daf57339aa89b42f94e65fa5d4be8.jpg?ts=1750191488",
      "https://www.eago.de/media/c7/b9/46/1750191488/615e69901048ea2044f54e7f51cfd4eb.jpg?ts=1750191488",
      "https://www.eago.de/media/df/12/ef/1750191488/34963fe5cc035a531259ff8b9e8ae6ae.jpg?ts=1750191488",
      "https://www.eago.de/media/1b/c1/68/1750191488/65752bcadffe9ec07ea29def3a45fada.jpg?ts=1750191488",
      "https://www.eago.de/media/d8/cb/82/1750191489/6aef974976b8805d62e19bdb19dc57b5.jpg?ts=1750191489",
      "https://www.eago.de/media/d6/72/08/1750191489/7cc722564b72831ef52e449ab686362b.jpg?ts=1750191489"
    ],
    "specs": {
      "Maße (innen)": "180 × 160 cm",
      "Außenmaße": "180 × 160 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "160.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Rote Zeder – Westliche Rotzeder, natürlich duftig",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16943"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Rote Zeder-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "160.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Rote Zeder",
            "text": "Rote Zeder (Western Red Cedar) aus Kanada ist seit Jahrzehnten das traditionelle Saunaholz für Premiumkabinen. Das Holz reguliert Feuchtigkeit natürlich, schwindet minimal und duftet angenehm holzig. Die warmen Rottöne sorgen für eine einzigartige Atmosphäre."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1603c-rote-zeder-180x180-9kw-cilindro",
    "title": "E1603C rote Zeder 180x180 9kW Cilindro",
    "price": "9.499,00 €",
    "cat": "Zeder",
    "img": "https://www.eago.de/media/8c/2c/f2/1750191565/045660d7d1ec06a3aceb43666821f595.jpg?ts=1750191565",
    "bg_id": "17030",
    "imgs": [
      "https://www.eago.de/media/8c/2c/f2/1750191565/045660d7d1ec06a3aceb43666821f595.jpg?ts=1750191565",
      "https://www.eago.de/media/14/d2/2c/1750191566/01394a8a7c3bd46cb1d7c1198c12a472.jpg?ts=1750191566",
      "https://www.eago.de/media/fc/f1/a5/1750191566/59f2e7791bfb9fd73f8ded1071d4ef0c.jpg?ts=1750191566",
      "https://www.eago.de/media/fd/6e/e5/1750191567/a54048c3b35438654164eb5bda2beeeb.jpg?ts=1750191567",
      "https://www.eago.de/media/03/eb/4e/1750191567/e67e3491e93dc7ade656408674b0c645.jpg?ts=1750191567",
      "https://www.eago.de/media/12/87/bd/1750191567/9916300a8294ee272a1ce0913d885852.jpg?ts=1750191567",
      "https://www.eago.de/media/87/56/f0/1750191568/cc5de8cc37ef759e316f271e2b88b3fa.jpg?ts=1750191568",
      "https://www.eago.de/media/3b/97/0a/1750191568/4c37f5c5d78666c6355696555623402f.jpg?ts=1750191568"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Rote Zeder – Westliche Rotzeder, natürlich duftig",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "16990"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Rote Zeder-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "180.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Rote Zeder",
            "text": "Rote Zeder (Western Red Cedar) aus Kanada ist seit Jahrzehnten das traditionelle Saunaholz für Premiumkabinen. Das Holz reguliert Feuchtigkeit natürlich, schwindet minimal und duftet angenehm holzig. Die warmen Rottöne sorgen für eine einzigartige Atmosphäre."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1604c-rote-zeder-160x150-6-8kw-cilindro",
    "title": "E1604C rote Zeder 160x150 6.8kW Cilindro",
    "price": "7.499,00 €",
    "cat": "Zeder",
    "img": "https://www.eago.de/media/a8/8c/8f/1750191671/7e22a626380cc9d9a2c446e8836458e2.jpg?ts=1750191671",
    "bg_id": "17070",
    "imgs": [
      "https://www.eago.de/media/a8/8c/8f/1750191671/7e22a626380cc9d9a2c446e8836458e2.jpg?ts=1750191671",
      "https://www.eago.de/media/39/52/f2/1750191672/9b66a227c1c4891a448a8cde44f944b2.jpg?ts=1750191672",
      "https://www.eago.de/media/95/51/b6/1750191672/35574fdc95d2a2a4d9816a4aed6a0018.jpg?ts=1750191672",
      "https://www.eago.de/media/0c/64/77/1750191673/3a4924de4ae8362bbcb7c8c975d5d8fe.jpg?ts=1750191673",
      "https://www.eago.de/media/a2/9c/f8/1750191673/d7cdb7482c33cbbf526ba318f247e2c9.jpg?ts=1750191673",
      "https://www.eago.de/media/f2/6f/84/1750191673/2a9b3646c5570baf0068bd39e77d894e.jpg?ts=1750191673",
      "https://www.eago.de/media/fc/0a/44/1750191674/f6b71beb321d24750634e589c12afb4d.jpg?ts=1750191674",
      "https://www.eago.de/media/00/a1/21/1750191674/5fd6e87ae7073e563cda90a5d010a501.jpg?ts=1750191674",
      "https://www.eago.de/media/1d/ed/7d/1750191674/6f723dbd6060d870433338710501c125.jpg?ts=1750191674",
      "https://www.eago.de/media/4b/58/ca/1750191675/8f886077ad9deafb4938e93ffb1987c0.jpg?ts=1750191675"
    ],
    "specs": {
      "Maße (innen)": "160 × 150 cm",
      "Außenmaße": "160 × 150 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (Kompakt)",
      "Ofenleistung": "6.8 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Rote Zeder – Westliche Rotzeder, natürlich duftig",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "1–2 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17052"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "10 mm ESG Sicherheitsglas (Tür 8 mm)",
                  "Hochwertiges Rote Zeder-Holz",
                  "Sandstein-Rückwand (ca. 50 mm / mit Sandstein 66 mm)",
                  "30 mm Isolierung – höhere Temperaturen bei geringerem Stromverbrauch",
                  "Saunabänke (oben + unten) & Holzboden",
                  "Decken- & Rückwandbeleuchtung mit LED-Farblicht",
                  "6.8 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Harvia Xenio Bedienfeld (computergesteuert, gradgenaue Einstellung)",
                  "Klimasteuerung & Frischluftzufuhr durch eingebaute Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Rote Zeder",
            "text": "Rote Zeder (Western Red Cedar) aus Kanada ist seit Jahrzehnten das traditionelle Saunaholz für Premiumkabinen. Das Holz reguliert Feuchtigkeit natürlich, schwindet minimal und duftet angenehm holzig. Die warmen Rottöne sorgen für eine einzigartige Atmosphäre."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1816a-pinienholz-220x220-9kw-vega",
    "title": "E1816A Pinienholz 220x220 9kW Vega",
    "price": "5.099,00 €",
    "cat": "Pinie",
    "img": "https://www.eago.de/media/52/c0/fb/1750278437/e9cada03c4e574394a4e12eefa51bf9f.jpg?ts=1750278437",
    "bg_id": "16532",
    "imgs": [
      "https://www.eago.de/media/52/c0/fb/1750278437/e9cada03c4e574394a4e12eefa51bf9f.jpg?ts=1750278437",
      "https://www.eago.de/media/0f/ca/80/1750278439/f10d54310f2e9c29f0df0d0bff2cff6b.jpg?ts=1750278439",
      "https://www.eago.de/media/c7/24/f2/1750278439/b0eb79391bde97da485e879c2d7d0c2a.jpg?ts=1750278439",
      "https://www.eago.de/media/82/0a/77/1750278439/648dbac28e7598915ae8446ed36102d5.jpg?ts=1750278439",
      "https://www.eago.de/media/d2/01/2d/1750278440/170de78ab549cd905e18a9393c8619eb.jpg?ts=1750278440",
      "https://www.eago.de/media/af/e6/a3/1750278440/cbfaab225729e14081af56f3d4b86829.jpg?ts=1750278440",
      "https://www.eago.de/media/1f/ee/d3/1750278440/b30d110476ee1b9362a12da4110cf7d0.jpg?ts=1750278440",
      "https://www.eago.de/media/48/35/c4/1750278441/6744ca2b2c8c9cd7a7e15224b2167f43.jpg?ts=1750278441",
      "https://www.eago.de/media/c2/6b/d8/1750278441/1e9cab990b68a4a8bbb1bcdc9284e802.jpg?ts=1750278441",
      "https://www.eago.de/media/2b/7d/a9/1750278441/2f7363c7b9ccd6b231df029faee60de4.jpg?ts=1750278441"
    ],
    "specs": {
      "Maße (innen)": "220 × 220 cm",
      "Außenmaße": "220 × 220 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (Eck)",
      "Ofenleistung": "220.9 kW",
      "Ofen": "Harvia Vega – Kompakter Wandofen, ideal für Heimsaunas",
      "Bedienfeld": "Harvia Xenio (opt.: Griffin App-Steuerung)",
      "Holzart": "Pinie – Nordische Kiefer, warm & charaktervoll",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "3–5 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17116"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pinie-Holz",
                  "220.9 kW Harvia Vega Saunaofen – kompakter Wandofen",
                  "Harvia Xenio Bedienfeld (computergesteuert)",
                  "Saunabänke & Holzboden",
                  "LED-Farblichtbeleuchtung",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Frischluftzufuhr durch Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Vega",
            "text": "Der Harvia Vega ist ein eleganter Wandofen mit 220.9 kW Leistung – ideal für kompakte Heimsaunas. Sein platzsparendes Design spart Bodenfläche und sorgt trotzdem für echte Saunahitze. Der Steinbehälter ist leicht zugänglich und liefert intensiven Aufgussdampf."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Nordische Pinie",
            "text": "Nordische Pinie (Pinus sylvestris) verleiht der Sauna ein warmes, charaktervolles Ambiente. Das harzreiche Holz duftet dezent und ist robust. Natürliche Äste und Maserungen sind gewünschte Holzmerkmale, die jeden Saunaraum zum Unikat machen."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1811b-pinienholz-160x160-6kw-vega",
    "title": "E1811B Pinienholz 160x160 6kW Vega",
    "price": "3.799,00 €",
    "cat": "Pinie",
    "img": "https://www.eago.de/media/3c/a6/b5/1750278342/03b8ad0a5b6c23da7e9e72a945616fd5.jpg?ts=1750278342",
    "bg_id": "16510",
    "imgs": [
      "https://www.eago.de/media/3c/a6/b5/1750278342/03b8ad0a5b6c23da7e9e72a945616fd5.jpg?ts=1750278342",
      "https://www.eago.de/media/67/33/04/1750278343/5e86cb888e83669bc0073e4e33ec4c90.jpg?ts=1750278343",
      "https://www.eago.de/media/c1/f4/28/1750278344/a2b71448ec33325b1df407647d8aab33.jpg?ts=1750278344",
      "https://www.eago.de/media/b3/2b/4d/1750278344/3f8d5bc6753b947be4958aa56889dcdb.jpg?ts=1750278344",
      "https://www.eago.de/media/00/98/52/1750278344/3061f4ea22219e33786b3b752e7228a9.jpg?ts=1750278344",
      "https://www.eago.de/media/ef/0f/53/1750278345/228920cb37272774181be2b0d14a0521.jpg?ts=1750278345",
      "https://www.eago.de/media/83/53/6a/1750278345/b41002f6e3d4c10d85f2af773da9b7bb.jpg?ts=1750278345",
      "https://www.eago.de/media/07/a2/2a/1750278345/b9e9307a23275ec57c02a8177c27cb76.jpg?ts=1750278345",
      "https://www.eago.de/media/3d/1f/53/1750278346/773b7d833cd9cdb4f0c6bb59ef980cc4.jpg?ts=1750278346",
      "https://www.eago.de/media/24/c2/1b/1750278346/ed39cf82d1dae2b568562e4eeea4aa6f.jpg?ts=1750278346"
    ],
    "specs": {
      "Maße (innen)": "160 × 160 cm",
      "Außenmaße": "160 × 160 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "160.6 kW",
      "Ofen": "Harvia Vega – Kompakter Wandofen, ideal für Heimsaunas",
      "Bedienfeld": "Harvia Xenio (opt.: Griffin App-Steuerung)",
      "Holzart": "Pinie – Nordische Kiefer, warm & charaktervoll",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17098"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pinie-Holz",
                  "160.6 kW Harvia Vega Saunaofen – kompakter Wandofen",
                  "Harvia Xenio Bedienfeld (computergesteuert)",
                  "Saunabänke & Holzboden",
                  "LED-Farblichtbeleuchtung",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Frischluftzufuhr durch Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Vega",
            "text": "Der Harvia Vega ist ein eleganter Wandofen mit 160.6 kW Leistung – ideal für kompakte Heimsaunas. Sein platzsparendes Design spart Bodenfläche und sorgt trotzdem für echte Saunahitze. Der Steinbehälter ist leicht zugänglich und liefert intensiven Aufgussdampf."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Nordische Pinie",
            "text": "Nordische Pinie (Pinus sylvestris) verleiht der Sauna ein warmes, charaktervolles Ambiente. Das harzreiche Holz duftet dezent und ist robust. Natürliche Äste und Maserungen sind gewünschte Holzmerkmale, die jeden Saunaraum zum Unikat machen."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1812c-pinienholz-180x160-8kw-vega",
    "title": "E1812C Pinienholz 180x160 8kW Vega",
    "price": "4.099,00 €",
    "cat": "Pinie",
    "img": "https://www.eago.de/media/8b/a5/2f/1750278391/0470efc70b3a7a0ad426e9ebc742b9c6.jpg?ts=1750278391",
    "bg_id": "16524",
    "imgs": [
      "https://www.eago.de/media/8b/a5/2f/1750278391/0470efc70b3a7a0ad426e9ebc742b9c6.jpg?ts=1750278391",
      "https://www.eago.de/media/f8/fd/f8/1750278392/a63407b7779c952a16940f38b5d4e159.jpg?ts=1750278392",
      "https://www.eago.de/media/dc/fc/03/1750278392/e7d0288891d7f81671dea17ea91a7ca3.jpg?ts=1750278392",
      "https://www.eago.de/media/86/56/3a/1750278393/8a0e60cbd525b93a04207c3e5acc3ccd.jpg?ts=1750278393",
      "https://www.eago.de/media/8d/34/da/1750278393/1cc337845989ec1c426f59dc8174138e.jpg?ts=1750278393",
      "https://www.eago.de/media/0e/b5/15/1750278393/6ce5efa39197c3f9c1efe46487ff34f7.jpg?ts=1750278393",
      "https://www.eago.de/media/c3/48/95/1750278394/a2a206ecfc9982581c542ca5be501e62.jpg?ts=1750278394",
      "https://www.eago.de/media/57/52/e2/1750278394/68b29b3329758398b334de3a11ae3dcd.jpg?ts=1750278394",
      "https://www.eago.de/media/d7/e8/60/1750278394/c12dc3da189e74c42bb8f6fd7bbc8afd.jpg?ts=1750278394",
      "https://www.eago.de/media/5d/d9/49/1750278395/1bcd888b1d833e3cfb2b747d45b171b5.jpg?ts=1750278395"
    ],
    "specs": {
      "Maße (innen)": "180 × 160 cm",
      "Außenmaße": "180 × 160 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "160.8 kW",
      "Ofen": "Harvia Vega – Kompakter Wandofen, ideal für Heimsaunas",
      "Bedienfeld": "Harvia Xenio (opt.: Griffin App-Steuerung)",
      "Holzart": "Pinie – Nordische Kiefer, warm & charaktervoll",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17101"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pinie-Holz",
                  "160.8 kW Harvia Vega Saunaofen – kompakter Wandofen",
                  "Harvia Xenio Bedienfeld (computergesteuert)",
                  "Saunabänke & Holzboden",
                  "LED-Farblichtbeleuchtung",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Frischluftzufuhr durch Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Vega",
            "text": "Der Harvia Vega ist ein eleganter Wandofen mit 160.8 kW Leistung – ideal für kompakte Heimsaunas. Sein platzsparendes Design spart Bodenfläche und sorgt trotzdem für echte Saunahitze. Der Steinbehälter ist leicht zugänglich und liefert intensiven Aufgussdampf."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Nordische Pinie",
            "text": "Nordische Pinie (Pinus sylvestris) verleiht der Sauna ein warmes, charaktervolles Ambiente. Das harzreiche Holz duftet dezent und ist robust. Natürliche Äste und Maserungen sind gewünschte Holzmerkmale, die jeden Saunaraum zum Unikat machen."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1813c-pinienholz-120x120-6kw-vega",
    "title": "E1813C Pinienholz 120x120 6kW Vega",
    "price": "2.799,00 €",
    "cat": "Pinie",
    "img": "https://www.eago.de/media/56/7d/9e/1750278424/7518fb374fa1ccb3a23bbf656b5d071a.jpg?ts=1750278424",
    "bg_id": "16529",
    "imgs": [
      "https://www.eago.de/media/56/7d/9e/1750278424/7518fb374fa1ccb3a23bbf656b5d071a.jpg?ts=1750278424",
      "https://www.eago.de/media/37/7d/bb/1750278425/cb664ea67cf5a68f6d881a7a13e08333.jpg?ts=1750278425",
      "https://www.eago.de/media/3b/27/8c/1750278426/032d98ac7570c3ec68b50a73a5d36f1b.jpg?ts=1750278426",
      "https://www.eago.de/media/61/d3/6e/1750278426/80d958ae561a292c542c526ea0a74365.jpg?ts=1750278426",
      "https://www.eago.de/media/2c/96/66/1750278426/2528fbff22f2150e1ac81c80a8c48fe8.jpg?ts=1750278426",
      "https://www.eago.de/media/22/59/00/1750278427/1e555849c09892c32ee78df934d1fbe6.jpg?ts=1750278427",
      "https://www.eago.de/media/5d/48/a5/1750278427/d75b248319b315ce13b0e4b1d04b9587.jpg?ts=1750278427",
      "https://www.eago.de/media/fd/c8/02/1750278427/95e975c9a13e72a4cb571368bce9e6a6.jpg?ts=1750278427"
    ],
    "specs": {
      "Maße (innen)": "120 × 120 cm",
      "Außenmaße": "120 × 120 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (Kompakt)",
      "Ofenleistung": "120.6 kW",
      "Ofen": "Harvia Vega – Kompakter Wandofen, ideal für Heimsaunas",
      "Bedienfeld": "Harvia Xenio (opt.: Griffin App-Steuerung)",
      "Holzart": "Pinie – Nordische Kiefer, warm & charaktervoll",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "1–2 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17104"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pinie-Holz",
                  "120.6 kW Harvia Vega Saunaofen – kompakter Wandofen",
                  "Harvia Xenio Bedienfeld (computergesteuert)",
                  "Saunabänke & Holzboden",
                  "LED-Farblichtbeleuchtung",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Frischluftzufuhr durch Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Vega",
            "text": "Der Harvia Vega ist ein eleganter Wandofen mit 120.6 kW Leistung – ideal für kompakte Heimsaunas. Sein platzsparendes Design spart Bodenfläche und sorgt trotzdem für echte Saunahitze. Der Steinbehälter ist leicht zugänglich und liefert intensiven Aufgussdampf."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Nordische Pinie",
            "text": "Nordische Pinie (Pinus sylvestris) verleiht der Sauna ein warmes, charaktervolles Ambiente. Das harzreiche Holz duftet dezent und ist robust. Natürliche Äste und Maserungen sind gewünschte Holzmerkmale, die jeden Saunaraum zum Unikat machen."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1806a-pinienholz-220x220-9kw-vega",
    "title": "E1806A Pinienholz 220x220 9kW Vega",
    "price": "3.999,00 €",
    "cat": "Pinie",
    "img": "https://www.eago.de/media/0b/98/a3/1750278300/f59263070c2cd1ad9b4d3cf04573fa5a.jpg?ts=1750278300",
    "bg_id": "16482",
    "imgs": [
      "https://www.eago.de/media/0b/98/a3/1750278300/f59263070c2cd1ad9b4d3cf04573fa5a.jpg?ts=1750278300",
      "https://www.eago.de/media/d3/50/5b/1750278302/58c409a810fa4aa28f6945b355708c4f.jpg?ts=1750278302",
      "https://www.eago.de/media/90/e6/aa/1750278302/5b2fc6336af75125e6e5e005f93e0080.jpg?ts=1750278302",
      "https://www.eago.de/media/ef/28/38/1750278302/adc93024109cedbbac80dde7125c5a37.jpg?ts=1750278302",
      "https://www.eago.de/media/a9/dd/1f/1750278303/aab122003d3fb0326715cc8ee440409b.jpg?ts=1750278303",
      "https://www.eago.de/media/c0/f9/7e/1750278303/fffcc203568323bc4ebe9907f53942d7.jpg?ts=1750278303",
      "https://www.eago.de/media/da/10/42/1750278303/c779402c107aaaebdb81b38f0d0f1791.jpg?ts=1750278303",
      "https://www.eago.de/media/f1/76/4d/1750278303/6f9df32b76045f94a68cc722403526d6.jpg?ts=1750278303",
      "https://www.eago.de/media/39/d7/ef/1750278304/a502817442f9c2431a0123dc347af2b0.jpg?ts=1750278304",
      "https://www.eago.de/media/13/4f/44/1750278304/c1b820111d1422f1ffbb58e54375e34f.jpg?ts=1750278304"
    ],
    "specs": {
      "Maße (innen)": "220 × 220 cm",
      "Außenmaße": "220 × 220 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (Eck)",
      "Ofenleistung": "220.9 kW",
      "Ofen": "Harvia Vega – Kompakter Wandofen, ideal für Heimsaunas",
      "Bedienfeld": "Harvia Xenio (opt.: Griffin App-Steuerung)",
      "Holzart": "Pinie – Nordische Kiefer, warm & charaktervoll",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "3–5 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17107"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pinie-Holz",
                  "220.9 kW Harvia Vega Saunaofen – kompakter Wandofen",
                  "Harvia Xenio Bedienfeld (computergesteuert)",
                  "Saunabänke & Holzboden",
                  "LED-Farblichtbeleuchtung",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Frischluftzufuhr durch Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Vega",
            "text": "Der Harvia Vega ist ein eleganter Wandofen mit 220.9 kW Leistung – ideal für kompakte Heimsaunas. Sein platzsparendes Design spart Bodenfläche und sorgt trotzdem für echte Saunahitze. Der Steinbehälter ist leicht zugänglich und liefert intensiven Aufgussdampf."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Nordische Pinie",
            "text": "Nordische Pinie (Pinus sylvestris) verleiht der Sauna ein warmes, charaktervolles Ambiente. Das harzreiche Holz duftet dezent und ist robust. Natürliche Äste und Maserungen sind gewünschte Holzmerkmale, die jeden Saunaraum zum Unikat machen."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1801b-pinienholz-160x160-6kw-vega",
    "title": "E1801B Pinienholz 160x160 6kW Vega",
    "price": "2.799,00 €",
    "cat": "Pinie",
    "img": "https://www.eago.de/media/a1/af/08/1750278169/8995e1326a3e9698e888719e5cb570b4.jpg?ts=1750278169",
    "bg_id": "14886",
    "imgs": [
      "https://www.eago.de/media/a1/af/08/1750278169/8995e1326a3e9698e888719e5cb570b4.jpg?ts=1750278169",
      "https://www.eago.de/media/a7/88/6d/1750278170/94e95598602793ec76a16cf2c81a6349.jpg?ts=1750278170",
      "https://www.eago.de/media/b4/4c/17/1750278171/33dd4a490fe0a0b290c13c874ee8a7c6.jpg?ts=1750278171",
      "https://www.eago.de/media/42/dc/a2/1750278171/ee0e07c7873e6642da0be7545c2cc110.jpg?ts=1750278171",
      "https://www.eago.de/media/93/06/fe/1750278171/0a5789784ca5c83a6942f554557ffc30.jpg?ts=1750278171",
      "https://www.eago.de/media/df/a1/9a/1750278172/669af9732b66b1e39f21ef2f145b13bf.jpg?ts=1750278172",
      "https://www.eago.de/media/32/8e/f3/1750278172/3f435b60b5aa4ba4e298a479fd83d7d8.jpg?ts=1750278172"
    ],
    "specs": {
      "Maße (innen)": "160 × 160 cm",
      "Außenmaße": "160 × 160 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "160.6 kW",
      "Ofen": "Harvia Vega – Kompakter Wandofen, ideal für Heimsaunas",
      "Bedienfeld": "Harvia Xenio (opt.: Griffin App-Steuerung)",
      "Holzart": "Pinie – Nordische Kiefer, warm & charaktervoll",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17089"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pinie-Holz",
                  "160.6 kW Harvia Vega Saunaofen – kompakter Wandofen",
                  "Harvia Xenio Bedienfeld (computergesteuert)",
                  "Saunabänke & Holzboden",
                  "LED-Farblichtbeleuchtung",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Frischluftzufuhr durch Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Vega",
            "text": "Der Harvia Vega ist ein eleganter Wandofen mit 160.6 kW Leistung – ideal für kompakte Heimsaunas. Sein platzsparendes Design spart Bodenfläche und sorgt trotzdem für echte Saunahitze. Der Steinbehälter ist leicht zugänglich und liefert intensiven Aufgussdampf."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Nordische Pinie",
            "text": "Nordische Pinie (Pinus sylvestris) verleiht der Sauna ein warmes, charaktervolles Ambiente. Das harzreiche Holz duftet dezent und ist robust. Natürliche Äste und Maserungen sind gewünschte Holzmerkmale, die jeden Saunaraum zum Unikat machen."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1802-pinienholz-180x180-8kw-vega",
    "title": "E1802 Pinienholz 180x180 8kW Vega",
    "price": "3.299,00 €",
    "cat": "Pinie",
    "img": "https://www.eago.de/media/dd/71/e3/1750278218/a4fb97cf698fdeb498fcfd83f8483cc8.jpg?ts=1750278218",
    "bg_id": "14887",
    "imgs": [
      "https://www.eago.de/media/dd/71/e3/1750278218/a4fb97cf698fdeb498fcfd83f8483cc8.jpg?ts=1750278218",
      "https://www.eago.de/media/a0/f3/d9/1750278219/dfc774d5ed1b9efd39e4e45952a35462.jpg?ts=1750278219",
      "https://www.eago.de/media/1e/6e/c8/1750278220/1c9c0eae6a0807b797ab211e22bba234.jpg?ts=1750278220",
      "https://www.eago.de/media/e7/93/e0/1750278220/ec921033cf0cdb892c7a461f3dfca867.jpg?ts=1750278220",
      "https://www.eago.de/media/e5/ec/27/1750278220/e8018b5e155886a34123ddf5872fdd12.jpg?ts=1750278220",
      "https://www.eago.de/media/bf/a8/2c/1750278221/5c08ed052d307d90718b27228df2e668.jpg?ts=1750278221",
      "https://www.eago.de/media/fd/23/37/1750278221/cea6b190ee7bc71718fc8ca57a17714e.jpg?ts=1750278221"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.8 kW",
      "Ofen": "Harvia Vega – Kompakter Wandofen, ideal für Heimsaunas",
      "Bedienfeld": "Harvia Xenio (opt.: Griffin App-Steuerung)",
      "Holzart": "Pinie – Nordische Kiefer, warm & charaktervoll",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17092"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pinie-Holz",
                  "180.8 kW Harvia Vega Saunaofen – kompakter Wandofen",
                  "Harvia Xenio Bedienfeld (computergesteuert)",
                  "Saunabänke & Holzboden",
                  "LED-Farblichtbeleuchtung",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Frischluftzufuhr durch Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Vega",
            "text": "Der Harvia Vega ist ein eleganter Wandofen mit 180.8 kW Leistung – ideal für kompakte Heimsaunas. Sein platzsparendes Design spart Bodenfläche und sorgt trotzdem für echte Saunahitze. Der Steinbehälter ist leicht zugänglich und liefert intensiven Aufgussdampf."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Nordische Pinie",
            "text": "Nordische Pinie (Pinus sylvestris) verleiht der Sauna ein warmes, charaktervolles Ambiente. Das harzreiche Holz duftet dezent und ist robust. Natürliche Äste und Maserungen sind gewünschte Holzmerkmale, die jeden Saunaraum zum Unikat machen."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1803c-pinienholz-120x120-6kw-vega",
    "title": "E1803C Pinienholz 120x120 6kW Vega",
    "price": "2.399,00 €",
    "cat": "Pinie",
    "img": "https://www.eago.de/media/39/cf/ba/1750278261/ebc473abdbf70ef26b4c904989390a79.jpg?ts=1750278261",
    "bg_id": "14891",
    "imgs": [
      "https://www.eago.de/media/39/cf/ba/1750278261/ebc473abdbf70ef26b4c904989390a79.jpg?ts=1750278261",
      "https://www.eago.de/media/dc/10/42/1750278263/ebc1d3cfd45f3e079ca3f4d619ac75b5.jpg?ts=1750278263",
      "https://www.eago.de/media/41/d9/a0/1750278263/cbaedf8a830a2b44eb4fea288893720e.jpg?ts=1750278263",
      "https://www.eago.de/media/41/47/c1/1750278263/1d9dbb86398816fb181d3cac0b249314.jpg?ts=1750278263",
      "https://www.eago.de/media/73/f7/48/1750278264/cf6d41a413218269bfdbe8c09925eb88.jpg?ts=1750278264",
      "https://www.eago.de/media/14/93/40/1750278264/f424a641166e2093f7aac3e2966bd4d7.jpg?ts=1750278264"
    ],
    "specs": {
      "Maße (innen)": "120 × 120 cm",
      "Außenmaße": "120 × 120 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (Kompakt)",
      "Ofenleistung": "120.6 kW",
      "Ofen": "Harvia Vega – Kompakter Wandofen, ideal für Heimsaunas",
      "Bedienfeld": "Harvia Xenio (opt.: Griffin App-Steuerung)",
      "Holzart": "Pinie – Nordische Kiefer, warm & charaktervoll",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "1–2 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17095"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pinie-Holz",
                  "120.6 kW Harvia Vega Saunaofen – kompakter Wandofen",
                  "Harvia Xenio Bedienfeld (computergesteuert)",
                  "Saunabänke & Holzboden",
                  "LED-Farblichtbeleuchtung",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Frischluftzufuhr durch Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Vega",
            "text": "Der Harvia Vega ist ein eleganter Wandofen mit 120.6 kW Leistung – ideal für kompakte Heimsaunas. Sein platzsparendes Design spart Bodenfläche und sorgt trotzdem für echte Saunahitze. Der Steinbehälter ist leicht zugänglich und liefert intensiven Aufgussdampf."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Nordische Pinie",
            "text": "Nordische Pinie (Pinus sylvestris) verleiht der Sauna ein warmes, charaktervolles Ambiente. Das harzreiche Holz duftet dezent und ist robust. Natürliche Äste und Maserungen sind gewünschte Holzmerkmale, die jeden Saunaraum zum Unikat machen."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1805-pinienholz-180x180-8kw-vega",
    "title": "E1805 Pinienholz 180x180 8kW Vega",
    "price": "3.299,00 €",
    "cat": "Pinie",
    "img": "https://www.eago.de/media/4b/66/0e/1750278287/7bdedc3513889fc729496bdca305a3fb.jpg?ts=1750278287",
    "bg_id": "14888",
    "imgs": [
      "https://www.eago.de/media/4b/66/0e/1750278287/7bdedc3513889fc729496bdca305a3fb.jpg?ts=1750278287",
      "https://www.eago.de/media/2e/2e/4c/1750278289/b287ab0cbecdc657dc93b7950d64b74d.jpg?ts=1750278289",
      "https://www.eago.de/media/8c/c6/fd/1750278289/56a5553cd67d5dd50268158fef88a335.jpg?ts=1750278289",
      "https://www.eago.de/media/8d/32/91/1750278289/9c9e4ddd46a1b24c9d3f65a1eafbde11.jpg?ts=1750278289",
      "https://www.eago.de/media/24/2e/7e/1750278290/c681d0130481c472bf73326176a8d19b.jpg?ts=1750278290",
      "https://www.eago.de/media/3d/3b/35/1750278290/513093755674db7ad64a93721085c2f4.jpg?ts=1750278290",
      "https://www.eago.de/media/a8/e3/e5/1750278290/8187130290e57c78cf935f82bf778e50.jpg?ts=1750278290"
    ],
    "specs": {
      "Maße (innen)": "180 × 180 cm",
      "Außenmaße": "180 × 180 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna",
      "Ofenleistung": "180.8 kW",
      "Ofen": "Harvia Vega – Kompakter Wandofen, ideal für Heimsaunas",
      "Bedienfeld": "Harvia Xenio (opt.: Griffin App-Steuerung)",
      "Holzart": "Pinie – Nordische Kiefer, warm & charaktervoll",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17110"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pinie-Holz",
                  "180.8 kW Harvia Vega Saunaofen – kompakter Wandofen",
                  "Harvia Xenio Bedienfeld (computergesteuert)",
                  "Saunabänke & Holzboden",
                  "LED-Farblichtbeleuchtung",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Frischluftzufuhr durch Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Vega",
            "text": "Der Harvia Vega ist ein eleganter Wandofen mit 180.8 kW Leistung – ideal für kompakte Heimsaunas. Sein platzsparendes Design spart Bodenfläche und sorgt trotzdem für echte Saunahitze. Der Steinbehälter ist leicht zugänglich und liefert intensiven Aufgussdampf."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Nordische Pinie",
            "text": "Nordische Pinie (Pinus sylvestris) verleiht der Sauna ein warmes, charaktervolles Ambiente. Das harzreiche Holz duftet dezent und ist robust. Natürliche Äste und Maserungen sind gewünschte Holzmerkmale, die jeden Saunaraum zum Unikat machen."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "e1804c-pinienholz-120x120-6kw-vega",
    "title": "E1804C Pinienholz 120x120 6kW Vega",
    "price": "2.399,00 €",
    "cat": "Pinie",
    "img": "https://www.eago.de/media/b6/5d/8d/1750278280/f79939038a0f5bd55ae649b2b2e8562b.jpg?ts=1750278280",
    "bg_id": "14929",
    "imgs": [
      "https://www.eago.de/media/b6/5d/8d/1750278280/f79939038a0f5bd55ae649b2b2e8562b.jpg?ts=1750278280",
      "https://www.eago.de/media/7a/cb/33/1750278282/7d1130026a403896f8ea30f65e3cc3df.jpg?ts=1750278282",
      "https://www.eago.de/media/f5/ee/0a/1750278282/b9aa61bcf91dfa4625e2b185345c4113.jpg?ts=1750278282",
      "https://www.eago.de/media/90/f1/80/1750278283/fa7acbc20d7c0087a3ce8dd14ee81cbf.jpg?ts=1750278283",
      "https://www.eago.de/media/90/f5/46/1750278283/a7558e5320c433cfd4cdebfcb3db00c3.jpg?ts=1750278283",
      "https://www.eago.de/media/bd/84/3d/1750278283/62c013964d74dd7225ff0c728423fce8.jpg?ts=1750278283",
      "https://www.eago.de/media/4d/93/9e/1750278284/ce7d803dd2cd99deefde69d016374d5c.jpg?ts=1750278284",
      "https://www.eago.de/media/22/12/4a/1750278284/14691a9ddaa78e36501d9070490147c9.jpg?ts=1750278284"
    ],
    "specs": {
      "Maße (innen)": "120 × 120 cm",
      "Außenmaße": "120 × 120 × 210 cm (L × B × H)",
      "Innenhöhe": "210 cm",
      "Typ": "Finnische Sauna (Kompakt)",
      "Ofenleistung": "120.6 kW",
      "Ofen": "Harvia Vega – Kompakter Wandofen, ideal für Heimsaunas",
      "Bedienfeld": "Harvia Xenio (opt.: Griffin App-Steuerung)",
      "Holzart": "Pinie – Nordische Kiefer, warm & charaktervoll",
      "Wandaufbau": "40 mm Profilholz + 50 mm Sandstein-Rückwand + 30 mm Isolierung",
      "Verglasung": "10 mm ESG (Tür 8 mm)",
      "Bestuhlung": "1–2 Personen",
      "Beleuchtung": "Indirekte LED-Farblichtbeleuchtung (Decke + Rückwand)",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17113"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "Hochwertiges Pinie-Holz",
                  "120.6 kW Harvia Vega Saunaofen – kompakter Wandofen",
                  "Harvia Xenio Bedienfeld (computergesteuert)",
                  "Saunabänke & Holzboden",
                  "LED-Farblichtbeleuchtung",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Frischluftzufuhr durch Lüftungsschlitze",
                  "Eigenes Ersatzteillager & technischer Support"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Vega",
            "text": "Der Harvia Vega ist ein eleganter Wandofen mit 120.6 kW Leistung – ideal für kompakte Heimsaunas. Sein platzsparendes Design spart Bodenfläche und sorgt trotzdem für echte Saunahitze. Der Steinbehälter ist leicht zugänglich und liefert intensiven Aufgussdampf."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Alternative Steuerungen (optional)",
            "items": [
                  "EOS D1 – Elektronisches Steuergerät, 24h-Echtzeituhr, 40–115 °C, Kindersicherung, made in Germany",
                  "EOS Emotec D (+500 €) – Premium-TFT-Display, 19 Sprachen, Wandmontage bis 100 m Kabelverlängerung",
                  "SBM-App Modul (999 €) – Sauna weltweit per App steuern, kompatibel mit Emotec D"
            ]
      },
      {
            "h": "Das Holz – Nordische Pinie",
            "text": "Nordische Pinie (Pinus sylvestris) verleiht der Sauna ein warmes, charaktervolles Ambiente. Das harzreiche Holz duftet dezent und ist robust. Natürliche Äste und Maserungen sind gewünschte Holzmerkmale, die jeden Saunaraum zum Unikat machen."
      },
      {
            "h": "Indirekte LED-Beleuchtung",
            "text": "Decke und Sandstein-Rückwand werden durch viele kleine LEDs indirekt beleuchtet. Lichtfarbe sanft wechselnd oder auf Wunschfarbe fixierbar – außergewöhnliche Wohlfühlatmosphäre."
      },
      {
            "h": "Frischluftzufuhr & Klimasteuerung",
            "text": "Durch eingebaute Lüftungsschlitze entsteht natürliche Konvektion: frische Luft steigt am Ofen auf, kühlt gegenüber ab und sinkt zu Boden. Regelbare Auslassklappe führt verbrauchte Luft nach außen – hoher Sauerstoffgehalt bei minimalem Energieverbrauch."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "the-cube-x2-hemlock-225x225-9kw-cilindro",
    "title": "THE CUBE X2 Hemlock 225x225 9kW Cilindro",
    "price": "19.999,00 €",
    "cat": "THE CUBE",
    "img": "https://www.eago.de/media/56/1a/ac/1750278472/0572e52cda308f33ee70988ffb841bdb.jpg?ts=1750278472",
    "bg_id": "16715",
    "imgs": [
      "https://www.eago.de/media/56/1a/ac/1750278472/0572e52cda308f33ee70988ffb841bdb.jpg?ts=1750278472",
      "https://www.eago.de/media/c7/06/d9/1750278473/88b3401ee6e64473cc71089c19238ef0.jpg?ts=1750278473",
      "https://www.eago.de/media/ac/8f/5e/1750278474/c441c559658277bdd4d4d71fb359f0fa.jpg?ts=1750278474",
      "https://www.eago.de/media/84/d8/9d/1750278474/4524a99982c3edb8498077fbe729b3b0.jpg?ts=1750278474",
      "https://www.eago.de/media/f2/29/b4/1750278475/5bfabe623a7655348edac6035ba77a5e.jpg?ts=1750278475",
      "https://www.eago.de/media/24/80/3f/1750278475/5259f9cb65fc11c974ac2dfc275ec427.jpg?ts=1750278475",
      "https://www.eago.de/media/87/7b/bb/1750278475/dacd539bf716e1f6c8babe9d1b069b79.jpg?ts=1750278475",
      "https://www.eago.de/media/8a/92/44/1750278475/71bf82fbf31bb9cbf5c16ec7cda1f96d.jpg?ts=1750278475",
      "https://www.eago.de/media/99/3a/5e/1750278476/0f482eb3db256e9b4a68bb9a96cda397.jpg?ts=1750278476"
    ],
    "specs": {
      "Maße (innen)": "225 × 225 cm",
      "Typ": "Außensauna / Saunahaus",
      "Ofenleistung": "225.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "45 mm Blockbohlen (nordische Fichte)",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "LED-Innenbeleuchtung",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Aufstellung": "Garten / Terrasse (Außenbereich)",
      "Dachform": "Flachdach mit Bitumenbahn",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17198"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "45 mm Blockbohlen aus nordischer Fichte – witterungsbeständig",
                  "Bitumenbahn-Flachdach",
                  "Saunabänke (oben + unten) & Holzboden",
                  "LED-Innenbeleuchtung",
                  "225.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Bedienfeld mit Zeitvorwahl",
                  "Montagefreundliches Stecksystem",
                  "Kostenloser Versand innerhalb Deutschlands"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Aufstellung & Gartensauna",
            "text": "THE CUBE ist als Außensauna für Garten und Terrasse konzipiert. Die massiven 45-mm-Blockbohlen aus nordischer Fichte sind witterungsbeständig und hervorragend isoliert. Das Flachdach mit professioneller Bitumenbahn schützt zuverlässig vor Regen und Schnee. Kein Fundament erforderlich – einfach auf ebenem Untergrund aufstellen."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "the-cube-x3-hemlock-225x225-9kw-cilindro",
    "title": "THE CUBE X3 Hemlock 225x225 9kW Cilindro",
    "price": "19.299,00 €",
    "cat": "THE CUBE",
    "img": "https://www.eago.de/media/62/6f/8c/1750278499/c2dda88671408ffcc7ba6e1b8d9a9f00.jpg?ts=1750278499",
    "bg_id": "16716",
    "imgs": [
      "https://www.eago.de/media/62/6f/8c/1750278499/c2dda88671408ffcc7ba6e1b8d9a9f00.jpg?ts=1750278499",
      "https://www.eago.de/media/db/a3/97/1750278501/1be85d2fd255b7dad54850362d92676b.jpg?ts=1750278501",
      "https://www.eago.de/media/12/3a/05/1750278501/6bc1d948ddd1e90bf3ec4ec96fd90395.jpg?ts=1750278501",
      "https://www.eago.de/media/f5/81/d4/1750278502/d4a175089eeb5e39f044b51da525401a.jpg?ts=1750278502",
      "https://www.eago.de/media/de/67/34/1750278502/5264e5c16fab5b8fd3e8a5203428788f.jpg?ts=1750278502",
      "https://www.eago.de/media/f5/47/2e/1750278502/b5f6d81606af82fab461bbb581f813f5.jpg?ts=1750278502",
      "https://www.eago.de/media/0e/00/34/1750278503/23b68c3cc872440357810852f25160b2.jpg?ts=1750278503",
      "https://www.eago.de/media/91/e0/d9/1750278503/3c93afa437fed0315dbc5e8c9ea3fd08.jpg?ts=1750278503",
      "https://www.eago.de/media/5f/9b/d3/1750278503/b24eecdca1e6c4e999961216e84f01d0.jpg?ts=1750278503",
      "https://www.eago.de/media/eb/7d/05/1750278504/db8e5666c5ba55eb417722fac859ddb6.jpg?ts=1750278504"
    ],
    "specs": {
      "Maße (innen)": "225 × 225 cm",
      "Typ": "Außensauna / Saunahaus",
      "Ofenleistung": "225.9 kW",
      "Ofen": "Harvia Cilindro – Zylinderförmiger Edelstahl-Ofen",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "45 mm Blockbohlen (nordische Fichte)",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "LED-Innenbeleuchtung",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Aufstellung": "Garten / Terrasse (Außenbereich)",
      "Dachform": "Flachdach mit Bitumenbahn",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17201"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "45 mm Blockbohlen aus nordischer Fichte – witterungsbeständig",
                  "Bitumenbahn-Flachdach",
                  "Saunabänke (oben + unten) & Holzboden",
                  "LED-Innenbeleuchtung",
                  "225.9 kW Harvia Cilindro Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Bedienfeld mit Zeitvorwahl",
                  "Montagefreundliches Stecksystem",
                  "Kostenloser Versand innerhalb Deutschlands"
            ]
      },
      {
            "h": "Der Saunaofen – Harvia Cilindro",
            "text": "Der Cilindro von Harvia ermöglicht einen echten finnischen Aufguss. Die große Steinmenge und die Steinkammer mit Edelstahl-Außengitter lassen sich stufenlos von weich bis sehr heiß regulieren – Wasser seitlich oder direkt auf die Steinsäule gießen. Kompakt und effizient auch für kleinere Räume."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Aufstellung & Gartensauna",
            "text": "THE CUBE ist als Außensauna für Garten und Terrasse konzipiert. Die massiven 45-mm-Blockbohlen aus nordischer Fichte sind witterungsbeständig und hervorragend isoliert. Das Flachdach mit professioneller Bitumenbahn schützt zuverlässig vor Regen und Schnee. Kein Fundament erforderlich – einfach auf ebenem Untergrund aufstellen."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "the-cube-x4-hemlock-235x235-9kw-eos-cubo",
    "title": "THE CUBE X4 Hemlock 235x235 9kW EOS Cubo",
    "price": "22.195,00 €",
    "cat": "THE CUBE",
    "img": "https://www.eago.de/media/76/33/54/1761220956/b9ba8655ede162071b90a032e1d9af2f.jpg?ts=1761220956",
    "bg_id": "17175",
    "imgs": [
      "https://www.eago.de/media/76/33/54/1761220956/b9ba8655ede162071b90a032e1d9af2f.jpg?ts=1761220956",
      "https://www.eago.de/media/67/2f/f7/1761220957/3f5f2879aa908f51851c3315a002ef5e.jpg?ts=1761220957",
      "https://www.eago.de/media/f9/60/85/1761220957/c3a98350a71d3e1a47790a5c78d4112f.jpg?ts=1761220958",
      "https://www.eago.de/media/6e/08/98/1761220958/bab673416039404c270ccd53dd550f65.jpg?ts=1761220958",
      "https://www.eago.de/media/62/e2/f7/1761220958/45a8b8068ead843ea849c935788f2236.jpg?ts=1761220958",
      "https://www.eago.de/media/c6/56/a0/1761220959/d1341c7e83077b3ffa83e34cf367c251.jpg?ts=1761220959",
      "https://www.eago.de/media/57/e9/e6/1761220959/3f28a03935ac3d1cb7602a222ca34071.jpg?ts=1761220959",
      "https://www.eago.de/media/19/e4/0a/1761220959/d55678618ac5d34f5dced43ded41ba5c.jpg?ts=1761220959",
      "https://www.eago.de/media/ca/ab/b8/1761220960/e0c8e9196a6c8140f70ce65f9383b956.jpg?ts=1761220960"
    ],
    "specs": {
      "Maße (innen)": "235 × 235 cm",
      "Typ": "Außensauna / Saunahaus",
      "Ofenleistung": "235.9 kW",
      "Ofen": "EOS Cubo – Kompakter Edelstahl-Ofen mit großer Steinkapazität",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "45 mm Blockbohlen (nordische Fichte)",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "LED-Innenbeleuchtung",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Aufstellung": "Garten / Terrasse (Außenbereich)",
      "Dachform": "Flachdach mit Bitumenbahn",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17204"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "45 mm Blockbohlen aus nordischer Fichte – witterungsbeständig",
                  "Bitumenbahn-Flachdach",
                  "Saunabänke (oben + unten) & Holzboden",
                  "LED-Innenbeleuchtung",
                  "235.9 kW EOS Cubo Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Bedienfeld mit Zeitvorwahl",
                  "Montagefreundliches Stecksystem",
                  "Kostenloser Versand innerhalb Deutschlands"
            ]
      },
      {
            "h": "Der Saunaofen – EOS Cubo",
            "text": "Der EOS Cubo vereint kompaktes Design mit maximaler Leistung. Mit 235.9 kW eignet er sich perfekt für moderne Außensaunas. Großes Steinvolumen, schnelles Aufheizen und einfache Bedienung machen ihn zum idealen Partner für THE CUBE."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Aufstellung & Gartensauna",
            "text": "THE CUBE ist als Außensauna für Garten und Terrasse konzipiert. Die massiven 45-mm-Blockbohlen aus nordischer Fichte sind witterungsbeständig und hervorragend isoliert. Das Flachdach mit professioneller Bitumenbahn schützt zuverlässig vor Regen und Schnee. Kein Fundament erforderlich – einfach auf ebenem Untergrund aufstellen."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "the-cube-x5-l-hemlock-235x235-9kw-eos-cubo",
    "title": "THE CUBE X5-L Hemlock 235x235 9kW EOS Cubo",
    "price": "25.195,00 €",
    "cat": "THE CUBE",
    "img": "https://www.eago.de/media/80/77/d3/1761221056/40665f69e2460d7655a01015fa67d87d.jpg?ts=1761221056",
    "bg_id": "17178",
    "imgs": [
      "https://www.eago.de/media/80/77/d3/1761221056/40665f69e2460d7655a01015fa67d87d.jpg?ts=1761221056",
      "https://www.eago.de/media/5f/85/17/1761221058/88262b664b53f366061fb1798504ba7a.jpg?ts=1761221058",
      "https://www.eago.de/media/fc/78/df/1761221058/9069454707cd224c1d80806336cf8f3b.jpg?ts=1761221058",
      "https://www.eago.de/media/6e/8a/e4/1761221058/d652503922a41026089cd05c066a663f.jpg?ts=1761221058",
      "https://www.eago.de/media/54/5e/f0/1761221059/01155212e1e3b054a1f39a43eb42fb09.jpg?ts=1761221059",
      "https://www.eago.de/media/63/a1/99/1761221059/6a6ddd4445f55851760cc26638fb4c0a.jpg?ts=1761221059",
      "https://www.eago.de/media/f3/b0/82/1761221060/b585167d2a14ae403ec58b19f9302e45.jpg?ts=1761221060",
      "https://www.eago.de/media/75/61/d1/1761221060/29f6902554432001e6cb025f4da9ce3b.jpg?ts=1761221060",
      "https://www.eago.de/media/94/12/1a/1761221060/fedfd76871bf7575d60f1a50d05e0b37.jpg?ts=1761221060",
      "https://www.eago.de/media/31/07/0a/1761221061/dcdaf506910fe40a95bf4e2cdd2d8845.jpg?ts=1761221061"
    ],
    "specs": {
      "Maße (innen)": "235 × 235 cm",
      "Typ": "Außensauna / Saunahaus",
      "Ofenleistung": "235.9 kW",
      "Ofen": "EOS Cubo – Kompakter Edelstahl-Ofen mit großer Steinkapazität",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "45 mm Blockbohlen (nordische Fichte)",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "LED-Innenbeleuchtung",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Aufstellung": "Garten / Terrasse (Außenbereich)",
      "Dachform": "Flachdach mit Bitumenbahn",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17205"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "45 mm Blockbohlen aus nordischer Fichte – witterungsbeständig",
                  "Bitumenbahn-Flachdach",
                  "Saunabänke (oben + unten) & Holzboden",
                  "LED-Innenbeleuchtung",
                  "235.9 kW EOS Cubo Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Bedienfeld mit Zeitvorwahl",
                  "Montagefreundliches Stecksystem",
                  "Kostenloser Versand innerhalb Deutschlands"
            ]
      },
      {
            "h": "Der Saunaofen – EOS Cubo",
            "text": "Der EOS Cubo vereint kompaktes Design mit maximaler Leistung. Mit 235.9 kW eignet er sich perfekt für moderne Außensaunas. Großes Steinvolumen, schnelles Aufheizen und einfache Bedienung machen ihn zum idealen Partner für THE CUBE."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Aufstellung & Gartensauna",
            "text": "THE CUBE ist als Außensauna für Garten und Terrasse konzipiert. Die massiven 45-mm-Blockbohlen aus nordischer Fichte sind witterungsbeständig und hervorragend isoliert. Das Flachdach mit professioneller Bitumenbahn schützt zuverlässig vor Regen und Schnee. Kein Fundament erforderlich – einfach auf ebenem Untergrund aufstellen."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "the-cube-x6-hemlock-300x235-12kw-eos-cubo",
    "title": "THE CUBE X6 Hemlock 300x235 12kW EOS Cubo",
    "price": "27.695,00 €",
    "cat": "THE CUBE",
    "img": "https://www.eago.de/media/c2/d2/c3/1758175928/d79069356b3d5664238913520cd07976.jpg?ts=1758175928",
    "bg_id": "17185",
    "imgs": [
      "https://www.eago.de/media/c2/d2/c3/1758175928/d79069356b3d5664238913520cd07976.jpg?ts=1758175928",
      "https://www.eago.de/media/75/21/28/1758175930/e47a89162f4785242005722e1946cf1a.jpg?ts=1758175930",
      "https://www.eago.de/media/35/fb/0e/1758175931/03fb5a22ba0d986aa92f184ebf69df4e.jpg?ts=1758175931",
      "https://www.eago.de/media/77/30/0a/1758175931/8038ea58a963e610c1616f5f0d230a1a.jpg?ts=1758175931",
      "https://www.eago.de/media/be/b3/05/1758175932/a0ac95252fe5712b2f613242393a6304.jpg?ts=1758175932",
      "https://www.eago.de/media/9b/90/98/1758175933/492d0b2136fb530a1594f31c9e808605.jpg?ts=1758175933",
      "https://www.eago.de/media/c9/47/62/1758175934/b947f65b64293427e81ef438130b3065.jpg?ts=1758175934",
      "https://www.eago.de/media/2e/c1/ec/1758175934/cf37f34e8036301cd8d37a227db1916d.jpg?ts=1758175934",
      "https://www.eago.de/media/b8/32/b0/1758175935/b3243d2449612a235d2390772802b50a.jpg?ts=1758175935",
      "https://www.eago.de/media/44/77/fe/1758175936/db16e577ac02f02c8ecd35564f2d0e72.jpg?ts=1758175936"
    ],
    "specs": {
      "Maße (innen)": "300 × 235 cm",
      "Typ": "Außensauna / Saunahaus",
      "Ofenleistung": "235.12 kW",
      "Ofen": "EOS Cubo – Kompakter Edelstahl-Ofen mit großer Steinkapazität",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "45 mm Blockbohlen (nordische Fichte)",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "LED-Innenbeleuchtung",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Aufstellung": "Garten / Terrasse (Außenbereich)",
      "Dachform": "Flachdach mit Bitumenbahn",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17207"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "45 mm Blockbohlen aus nordischer Fichte – witterungsbeständig",
                  "Bitumenbahn-Flachdach",
                  "Saunabänke (oben + unten) & Holzboden",
                  "LED-Innenbeleuchtung",
                  "235.12 kW EOS Cubo Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Bedienfeld mit Zeitvorwahl",
                  "Montagefreundliches Stecksystem",
                  "Kostenloser Versand innerhalb Deutschlands"
            ]
      },
      {
            "h": "Der Saunaofen – EOS Cubo",
            "text": "Der EOS Cubo vereint kompaktes Design mit maximaler Leistung. Mit 235.12 kW eignet er sich perfekt für moderne Außensaunas. Großes Steinvolumen, schnelles Aufheizen und einfache Bedienung machen ihn zum idealen Partner für THE CUBE."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Aufstellung & Gartensauna",
            "text": "THE CUBE ist als Außensauna für Garten und Terrasse konzipiert. Die massiven 45-mm-Blockbohlen aus nordischer Fichte sind witterungsbeständig und hervorragend isoliert. Das Flachdach mit professioneller Bitumenbahn schützt zuverlässig vor Regen und Schnee. Kein Fundament erforderlich – einfach auf ebenem Untergrund aufstellen."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "the-cube-x7-l-hemlock-300x235-12kw-eos-cubo",
    "title": "THE CUBE X7-L Hemlock 300x235 12kW EOS Cubo",
    "price": "29.695,00 €",
    "cat": "THE CUBE",
    "img": "https://www.eago.de/media/dc/55/3a/1759469455/bd59e17f40bc991a777fdc1f646bed4b.jpg?ts=1759469455",
    "bg_id": "17188",
    "imgs": [
      "https://www.eago.de/media/dc/55/3a/1759469455/bd59e17f40bc991a777fdc1f646bed4b.jpg?ts=1759469455",
      "https://www.eago.de/media/ee/b2/d6/1759469456/836ace3a6bf7b91bd257e247cf187c5e.jpg?ts=1759469456",
      "https://www.eago.de/media/f3/1c/b1/1759469456/90edd84ffcbaf749495fe16b19483e0b.jpg?ts=1759469456",
      "https://www.eago.de/media/f1/aa/b5/1759469457/a9f4fc221cd4c812392deb0151f2401f.jpg?ts=1759469457",
      "https://www.eago.de/media/04/fc/b7/1759469457/b9e16942f80cc0690a032713f153a37a.jpg?ts=1759469457",
      "https://www.eago.de/media/1a/4e/17/1759469457/5efc4a3e70b2477dd26ed17c0f323447.jpg?ts=1759469457",
      "https://www.eago.de/media/de/2d/13/1759469458/2e69c47f7b0684426a44b065c09edd34.jpg?ts=1759469458",
      "https://www.eago.de/media/79/17/8a/1759469458/9694e219d0a64720cc23480a45073930.jpg?ts=1759469458",
      "https://www.eago.de/media/00/ca/6a/1759469458/14edce56a3f84354775a4710e69f816b.jpg?ts=1759469458",
      "https://www.eago.de/media/b0/c4/c0/1759469459/5a0b1a15daf9e560f4869259d0f1bd76.jpg?ts=1759469459"
    ],
    "specs": {
      "Maße (innen)": "300 × 235 cm",
      "Typ": "Außensauna / Saunahaus",
      "Ofenleistung": "235.12 kW",
      "Ofen": "EOS Cubo – Kompakter Edelstahl-Ofen mit großer Steinkapazität",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "45 mm Blockbohlen (nordische Fichte)",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "LED-Innenbeleuchtung",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Aufstellung": "Garten / Terrasse (Außenbereich)",
      "Dachform": "Flachdach mit Bitumenbahn",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17208"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "45 mm Blockbohlen aus nordischer Fichte – witterungsbeständig",
                  "Bitumenbahn-Flachdach",
                  "Saunabänke (oben + unten) & Holzboden",
                  "LED-Innenbeleuchtung",
                  "235.12 kW EOS Cubo Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Bedienfeld mit Zeitvorwahl",
                  "Montagefreundliches Stecksystem",
                  "Kostenloser Versand innerhalb Deutschlands"
            ]
      },
      {
            "h": "Der Saunaofen – EOS Cubo",
            "text": "Der EOS Cubo vereint kompaktes Design mit maximaler Leistung. Mit 235.12 kW eignet er sich perfekt für moderne Außensaunas. Großes Steinvolumen, schnelles Aufheizen und einfache Bedienung machen ihn zum idealen Partner für THE CUBE."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Aufstellung & Gartensauna",
            "text": "THE CUBE ist als Außensauna für Garten und Terrasse konzipiert. Die massiven 45-mm-Blockbohlen aus nordischer Fichte sind witterungsbeständig und hervorragend isoliert. Das Flachdach mit professioneller Bitumenbahn schützt zuverlässig vor Regen und Schnee. Kein Fundament erforderlich – einfach auf ebenem Untergrund aufstellen."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "the-cube-x7-l-pro-hemlock-300x635-12kw-eos-cubo",
    "title": "THE CUBE X7-L pro Hemlock 300x635 12kW EOS Cubo",
    "price": "34.494,00 €",
    "cat": "THE CUBE",
    "img": "https://www.eago.de/media/dc/55/3a/1759469455/bd59e17f40bc991a777fdc1f646bed4b.jpg?ts=1759469455",
    "bg_id": "17204",
    "imgs": [
      "https://www.eago.de/media/dc/55/3a/1759469455/bd59e17f40bc991a777fdc1f646bed4b.jpg?ts=1759469455",
      "https://www.eago.de/media/ee/b2/d6/1759469456/836ace3a6bf7b91bd257e247cf187c5e.jpg?ts=1759469456",
      "https://www.eago.de/media/f3/1c/b1/1759469456/90edd84ffcbaf749495fe16b19483e0b.jpg?ts=1759469456",
      "https://www.eago.de/media/f1/aa/b5/1759469457/a9f4fc221cd4c812392deb0151f2401f.jpg?ts=1759469457",
      "https://www.eago.de/media/04/fc/b7/1759469457/b9e16942f80cc0690a032713f153a37a.jpg?ts=1759469457",
      "https://www.eago.de/media/1a/4e/17/1759469457/5efc4a3e70b2477dd26ed17c0f323447.jpg?ts=1759469457",
      "https://www.eago.de/media/de/2d/13/1759469458/2e69c47f7b0684426a44b065c09edd34.jpg?ts=1759469458",
      "https://www.eago.de/media/79/17/8a/1759469458/9694e219d0a64720cc23480a45073930.jpg?ts=1759469458",
      "https://www.eago.de/media/00/ca/6a/1759469458/14edce56a3f84354775a4710e69f816b.jpg?ts=1759469458",
      "https://www.eago.de/media/b0/c4/c0/1759469459/5a0b1a15daf9e560f4869259d0f1bd76.jpg?ts=1759469459"
    ],
    "specs": {
      "Maße (innen)": "300 × 635 cm",
      "Typ": "Außensauna / Saunahaus",
      "Ofenleistung": "635.12 kW",
      "Ofen": "EOS Cubo – Kompakter Edelstahl-Ofen mit großer Steinkapazität",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "45 mm Blockbohlen (nordische Fichte)",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "LED-Innenbeleuchtung",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Aufstellung": "Garten / Terrasse (Außenbereich)",
      "Dachform": "Flachdach mit Bitumenbahn",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17210"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "45 mm Blockbohlen aus nordischer Fichte – witterungsbeständig",
                  "Bitumenbahn-Flachdach",
                  "Saunabänke (oben + unten) & Holzboden",
                  "LED-Innenbeleuchtung",
                  "635.12 kW EOS Cubo Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Bedienfeld mit Zeitvorwahl",
                  "Montagefreundliches Stecksystem",
                  "Kostenloser Versand innerhalb Deutschlands"
            ]
      },
      {
            "h": "Der Saunaofen – EOS Cubo",
            "text": "Der EOS Cubo vereint kompaktes Design mit maximaler Leistung. Mit 635.12 kW eignet er sich perfekt für moderne Außensaunas. Großes Steinvolumen, schnelles Aufheizen und einfache Bedienung machen ihn zum idealen Partner für THE CUBE."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Aufstellung & Gartensauna",
            "text": "THE CUBE ist als Außensauna für Garten und Terrasse konzipiert. Die massiven 45-mm-Blockbohlen aus nordischer Fichte sind witterungsbeständig und hervorragend isoliert. Das Flachdach mit professioneller Bitumenbahn schützt zuverlässig vor Regen und Schnee. Kein Fundament erforderlich – einfach auf ebenem Untergrund aufstellen."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
  {
    "handle": "the-cube-x7-r-pro-hemlock-300x635-12kw-eos-cubo",
    "title": "THE CUBE X7-R pro Hemlock 300x635 12kW EOS Cubo",
    "price": "34.494,00 €",
    "cat": "THE CUBE",
    "img": "https://www.eago.de/media/dc/55/3a/1759469455/bd59e17f40bc991a777fdc1f646bed4b.jpg?ts=1759469455",
    "bg_id": "17207",
    "imgs": [
      "https://www.eago.de/media/dc/55/3a/1759469455/bd59e17f40bc991a777fdc1f646bed4b.jpg?ts=1759469455",
      "https://www.eago.de/media/ee/b2/d6/1759469456/836ace3a6bf7b91bd257e247cf187c5e.jpg?ts=1759469456",
      "https://www.eago.de/media/f3/1c/b1/1759469456/90edd84ffcbaf749495fe16b19483e0b.jpg?ts=1759469456",
      "https://www.eago.de/media/f1/aa/b5/1759469457/a9f4fc221cd4c812392deb0151f2401f.jpg?ts=1759469457",
      "https://www.eago.de/media/04/fc/b7/1759469457/b9e16942f80cc0690a032713f153a37a.jpg?ts=1759469457",
      "https://www.eago.de/media/1a/4e/17/1759469457/5efc4a3e70b2477dd26ed17c0f323447.jpg?ts=1759469457",
      "https://www.eago.de/media/de/2d/13/1759469458/2e69c47f7b0684426a44b065c09edd34.jpg?ts=1759469458",
      "https://www.eago.de/media/79/17/8a/1759469458/9694e219d0a64720cc23480a45073930.jpg?ts=1759469458",
      "https://www.eago.de/media/00/ca/6a/1759469458/14edce56a3f84354775a4710e69f816b.jpg?ts=1759469458",
      "https://www.eago.de/media/b0/c4/c0/1759469459/5a0b1a15daf9e560f4869259d0f1bd76.jpg?ts=1759469459"
    ],
    "specs": {
      "Maße (innen)": "300 × 635 cm",
      "Typ": "Außensauna / Saunahaus",
      "Ofenleistung": "635.12 kW",
      "Ofen": "EOS Cubo – Kompakter Edelstahl-Ofen mit großer Steinkapazität",
      "Bedienfeld": "Harvia Xenio (opt.: Xenio WIFI, EOS D1, EOS Emotec D)",
      "Holzart": "Hemlock – Kanadische Hemlocktanne, aromafrei",
      "Wandaufbau": "45 mm Blockbohlen (nordische Fichte)",
      "Verglasung": "8 mm ESG Sicherheitsglas",
      "Bestuhlung": "2–4 Personen",
      "Beleuchtung": "LED-Innenbeleuchtung",
      "Aufheizzeit": "ca. 15–20 Minuten (bei voller Leistung)",
      "Betriebstemp.": "60–90 °C empfohlen, max. 95 °C",
      "Anschluss": "Starkstrom 400 V / 16 A (nur Fachbetrieb)",
      "Aufstellung": "Garten / Terrasse (Außenbereich)",
      "Dachform": "Flachdach mit Bitumenbahn",
      "Lieferumfang": "Ofen, Bedienfeld, Bänke, Holzboden, Thermometer, Sanduhr, Eimer + Kelle",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage",
      "Art. Nr.": "17211"
},
    "desc": [
      {
            "h": "Lieferumfang & Ausstattung",
            "items": [
                  "8 mm ESG Sicherheitsglas",
                  "45 mm Blockbohlen aus nordischer Fichte – witterungsbeständig",
                  "Bitumenbahn-Flachdach",
                  "Saunabänke (oben + unten) & Holzboden",
                  "LED-Innenbeleuchtung",
                  "635.12 kW EOS Cubo Saunaofen",
                  "Thermometer, Sanduhr, Aufgusseimer + Kelle",
                  "Bedienfeld mit Zeitvorwahl",
                  "Montagefreundliches Stecksystem",
                  "Kostenloser Versand innerhalb Deutschlands"
            ]
      },
      {
            "h": "Der Saunaofen – EOS Cubo",
            "text": "Der EOS Cubo vereint kompaktes Design mit maximaler Leistung. Mit 635.12 kW eignet er sich perfekt für moderne Außensaunas. Großes Steinvolumen, schnelles Aufheizen und einfache Bedienung machen ihn zum idealen Partner für THE CUBE."
      },
      {
            "h": "Bedienfeld – Harvia Xenio",
            "text": "Das kompakte Xenio zeigt Betriebstemperatur, Restlaufzeit und Beleuchtungsstatus. Wand- oder Einbaumontage möglich. Betriebszeit und Temperatur gradgenau einstellbar. Optional mit WIFI-Modul – Sauna bereits warm, wenn man nach Hause kommt."
      },
      {
            "h": "Das Holz – Hemlock",
            "text": "Hemlock stammt aus Kanada und der Westküste Nordamerikas. Geringes Gewicht, gleichmäßige Färbung, keine Harzabgabe bei hohen Temperaturen – ideal für den Saunabau. Typische Mineralstreifen und Rindeneinschlüsse sind natürliche Holzmerkmale, kein Mangel."
      },
      {
            "h": "Aufstellung & Gartensauna",
            "text": "THE CUBE ist als Außensauna für Garten und Terrasse konzipiert. Die massiven 45-mm-Blockbohlen aus nordischer Fichte sind witterungsbeständig und hervorragend isoliert. Das Flachdach mit professioneller Bitumenbahn schützt zuverlässig vor Regen und Schnee. Kein Fundament erforderlich – einfach auf ebenem Untergrund aufstellen."
      },
      {
            "h": "Sicherheitshinweise",
            "items": [
                  "Nutzung bei Herz-Kreislauf, Bluthochdruck oder Diabetes nur nach Arztabsprache",
                  "Nicht unter Einfluss von Alkohol, Drogen oder Medikamenten nutzen",
                  "Kinder nur unter Aufsicht Erwachsener",
                  "Max. 20 Minuten Aufenthalt, max. 95 °C Betriebstemperatur",
                  "Elektroanschluss nur durch qualifizierten Fachbetrieb",
                  "5–10 cm Abstand zu angrenzenden Wänden einhalten",
                  "Nach Montage versiegeln, 24h vor Erstnutzung warten"
            ]
      }
]
},
{
    "handle": "awt-in-392-classic-extreme-silvermarble-240x240-grau",
    "title": "AWT IN-392 Classic 240 × 240",
    "price": "7.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/2a/9b/b4/1750798083/6b20989290adac554f306b909eff4c45.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/2a/9b/b4/1750798083/6b20989290adac554f306b909eff4c45.jpg",
      "https://www.eago.de/media/dc/02/d3/1750798084/6689979de5fce2b498a732092d43aa3b.jpg",
      "https://www.eago.de/media/3d/60/d2/1750798084/1428667098889f2ebf6b588f4a0b7f80.jpg",
      "https://www.eago.de/media/08/69/27/1750798085/299fe7b094b023b05244e52c07a00776.jpg",
      "https://www.eago.de/media/e6/8b/01/1750798085/550a69b2f84668832a76b24c54dea902.jpg",
      "https://www.eago.de/media/4f/53/d9/1750798085/016cbb1180fcbe630eff68895cc51855.jpg",
      "https://www.eago.de/media/05/fb/88/1750798086/729ae47e800d1534b4c0c6b1cf3f86e0.jpg",
      "https://www.eago.de/media/af/fb/f7/1750798086/ce0b7bf220334d9a393afb78e0c01c08.jpg",
      "https://www.eago.de/media/26/9c/69/1750798086/0f77e783eb8e2926c2698ac2b56a37d1.jpg",
      "https://www.eago.de/media/14/73/9d/1750798087/81040fd74565802d61a90b8831097887.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 6 Personen",
      "Massagejets": "70 Jets",
      "Heizleistung": "3 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl",
      "Wasserkapazität": "2000 Liter",
      "Gewicht (leer)": "477 kg",
      "Elektr. Absicherung": "3 × 16A",
      "Außenmaße": "2400 × 2400 × 100 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Salzwasser-Desinfektionssystem",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Die extreme Version ist eine Sonderedition unserer Innovation Aussenwhirlpool-Serie, die viele tolle Zusatzfunktionen als Komplettpaket zu einem unschlagbaren Preis enthält. Enthalten in unserer Sonderedition sind Musikpaket (Streamen Sie Musik direkt von Ihre Smartphone oder Tablet - Einzelpreis 499 EUR), Licht- und Designpaket (Exklusive beleuchtete Design-Jets, weitere oder stärkere Pumpen Einzelpreis 999 EUR) und eine Salzwasser-Desinfektionsanlage - nie wieder chloren Einzelpreis 1.499 EUR). Sie sparen im Vergleich zu den Einzelkomponenten 998 EUR."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für 6 Personen",
                  "Insgesamt 70 beleuchtet Design-Jets von RisingDragon (33 rotierende Hydrojets, 37 feststehende Jets).",
                  "4 Pumpen (3 Hydropumpen mit je 1.500W und eine Umwälzpumpe)",
                  "Ambiente Farblicht mit vielen Funktionen wie Fade für die totale Entspannung",
                  "Dezente LED-Beleuchtung (28 Lampen) unter den Kopfstürzen und im Filterbereich",
                  "2 beleuchtete Regler zur Luftbeimischung",
                  "2 beleuchtete Fountainen",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekte",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht. Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Musikpaket mit zwei Lautsprechern - streamen der Lieblingsmusik oder Internetradio vom Smartphone",
                  "Weitere Erweiterungsmodule wie z.B. die Steuerung des Whirlpools per Smartphone oder Tablet sind optional erhältlich",
                  "Heizung mit Temperaturwahl (3kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Salzwasser-Desinfektionssystem - Reduziert den Pflegeaufwand für den Pool erheblich und schafft gleichzeitig ein weiches hautfreundliches Wasser",
                  "Geschlossene, isolierte Bodenplatte aus GFKExtreme Isolation = geringe Unterhaltskosten. Durch die einzigartige Wärmedämmung wird der Energieverbrauch des Pools auf ein Minimum reduziert. Die Abwärme der Pumpen wird zur Erwärmung des Wassers verwertet - somit geht so gut wie keine Energie verloren.",
                  "Hochwertiges Acryl von Aristech (USA) mit antibakterieller Oberfläche (lieferbar in 7 verschieden Farben)",
                  "Armlehnen für ein entspanntes Liegen im Pool",
                  "Auslieferung komplett anschlussfertig inkl. Schürze und einer stabilen extra isolierten Abdeckplane (80mm)",
                  "Inklusive Treppe",
                  "Wasserkapazität 2000 Liter",
                  "Gewicht 477 kg, elektrische Absicherung: 3x16A",
                  "2400mm x 2400mm x 100mm (Länge x Breite x Höhe)",
                  "24 Monate deutschlandweiter Vor-Ort-Service (ausgenommen ist der Tausch von Verschleißteilen wie Leuchtmitteln) durch eigenen Kundendienst. Wir bieten Ihnen selbstverständlich einen Ersatzteilservice auch nach der Gewährleistungszeit"
            ]
      }
    ]
  },
{
    "handle": "awt-in-401-basic-sterling-silver-200x200-grau",
    "title": "AWT IN-401 Basic 200 × 200",
    "price": "4.299,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/13/a9/a2/1750798107/ad858da60b9305c4e5b4f8bd48d6753e.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/13/a9/a2/1750798107/ad858da60b9305c4e5b4f8bd48d6753e.jpg",
      "https://www.eago.de/media/2d/d4/74/1750798108/b98cc0d78dcb9e19df6da5ba32d7b739.jpg",
      "https://www.eago.de/media/a3/7a/5c/1750798109/2f587066f444bf25809e054ebb12e0c2.jpg",
      "https://www.eago.de/media/61/93/4b/1750798109/49ebbfd8830fff9ea1d8909accfe4645.jpg",
      "https://www.eago.de/media/d0/ea/14/1750798109/4624beb49d3bca32be7a5ae27b489eee.jpg",
      "https://www.eago.de/media/6f/6b/df/1750798110/eacd32e4d2520197d69d113a8a10ab2d.jpg",
      "https://www.eago.de/media/b0/bf/a8/1750798110/46ec3d5e3c1055e7ad0756857cbe6fd7.jpg",
      "https://www.eago.de/media/dc/f5/38/1750798111/b4e703ae85263ea92da2fbd3b00c47b8.jpg",
      "https://www.eago.de/media/24/c0/4e/1750798111/4d7174d882f39dd8d67922e21aed6f67.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 6 Personen",
      "Massagejets": "30 Jets",
      "Pumpen": "Hydropumpe LX 1800W",
      "Heizleistung": "2 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe SterlingSilver",
      "Wasserkapazität": "1250 Liter",
      "Gewicht (leer)": "300 kg",
      "Elektr. Absicherung": "1 × 16 A",
      "Anschluss": "Plug & Play – 230-V-Steckdose",
      "Außenmaße": "2000 × 2000 × 900 mm (L × B × H)",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. isolierte Abdeckplane",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Lassen Sie sich durch unsere SPA´s begeistern. Entspannen Sie in angenehmer Atmosphäre und stärken Sie so Ihr Immunsystem und ihren Kreislauf. Von dem Moment an, wo Sie sich in das warme, angenehme Wasser unserer AWT Aussenwhirlpools begeben, werden Sie den Alltag vergessen. Rückenschmerzen werden gelindert und Stress gehört der Vergangenheit an. Ihr Wohlbefinden wird hierdurch deutlich verbessert."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 6 Personen",
                  "30 Hydrojets (14 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "Dual-Speed Hydropumpe von LX mit 1800W",
                  "Zirkulationsmodus mit 350W",
                  "Gecko Computersystem",
                  "Farblicht",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (2kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe SterlingSilver",
                  "3 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Wasserkapazität 1250 Liter",
                  "Gewicht 300kg",
                  "Empfohlene elektrische Absicherung: 1 × 16 A",
                  "Geräteanschluss: Plug & Play – einfach an eine 230-V-Steckdose anschließen und starten",
                  "2000mm x 2000mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-401-eco-sterling-silver-200x200-grau",
    "title": "AWT IN-401 Eco 200 × 200",
    "price": "4.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/a0/b4/f4/1750709868/18da22afb38ba7baa88edcbf37abe045.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/a0/b4/f4/1750709868/18da22afb38ba7baa88edcbf37abe045.jpg",
      "https://www.eago.de/media/bb/28/f9/1750709869/62f25b36beb6892776a191cbca97e2ec.jpg",
      "https://www.eago.de/media/2b/8d/73/1750709869/feba9058c4fab529cfc21ad157fa0582.jpg",
      "https://www.eago.de/media/37/3d/6a/1750709870/c656503e2ee3a725f9fe76e7bb91acab.jpg",
      "https://www.eago.de/media/cc/33/3a/1750709870/3ddd6875acff317b472adce15ce09397.jpg",
      "https://www.eago.de/media/ee/de/e4/1750709870/7ef6d417ed680c06269698ef0e01aeda.jpg",
      "https://www.eago.de/media/22/69/b6/1750709871/9152245fa28d05bcb7dc40ef3d03d5ec.jpg",
      "https://www.eago.de/media/c6/3b/92/1750709871/7c154bc9f0c068fb9917eab07f6d90f4.jpg",
      "https://www.eago.de/media/47/b7/93/1756386801/60fd5caf4c39dd9c308f2ec3b169803a.jpg",
      "https://www.eago.de/media/d6/ef/88/1750709872/f257ec0e8a3246201775e27551d73f60.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 6 Personen",
      "Massagejets": "30 Jets",
      "Pumpen": "Hydropumpe LX 1800W, Zirkulationspumpe LX 180W",
      "Heizleistung": "2 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe SterlingSilver",
      "Wasserkapazität": "1250 Liter",
      "Gewicht (leer)": "300 kg",
      "Elektr. Absicherung": "1 × 16 A",
      "Anschluss": "Plug & Play – 230-V-Steckdose",
      "Außenmaße": "2000 × 2000 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Lassen Sie sich durch unsere SPA´s begeistern. Entspannen Sie in angenehmer Atmosphäre und stärken Sie so Ihr Immunsystem und ihren Kreislauf. Von dem Moment an, wo Sie sich in das warme, angenehme Wasser unserer AWT Aussenwhirlpools begeben, werden Sie den Alltag vergessen. Rückenschmerzen werden gelindert und Stress gehört der Vergangenheit an. Ihr Wohlbefinden wird hierdurch deutlich verbessert."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 6 Personen in Vollausstattung",
                  "30 Hydrojets (14 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "Energiesparende Hydropumpe von LX mit 1800W",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht. Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Webmodul zur Steuerung des Whirlpools per Smartphone oder Tablet.Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade oder Party Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung (42 Lampen) unter den Kopfstürzen, im Filterbereich und im Pool",
                  "3 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (2kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe SterlingSilver",
                  "3 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFKAuslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Inkl. Treppe",
                  "Wasserkapazität 1250 Liter",
                  "Gewicht 300kg",
                  "Empfohlene elektrische Absicherung: 1 × 16 A",
                  "Geräteanschluss: Plug & Play – einfach an eine 230-V-Steckdose anschließen und starten",
                  "2000mm x 2000mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-402-eco-sterling-silver-200x200-grau",
    "title": "AWT IN-402 Eco 200 × 200",
    "price": "5.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/a0/a7/66/1750709880/6caa89213a0a18ce85ff01393d6ba2e7.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/a0/a7/66/1750709880/6caa89213a0a18ce85ff01393d6ba2e7.jpg",
      "https://www.eago.de/media/fe/66/44/1750709882/de495e45444993d1e03449aecd9c4203.jpg",
      "https://www.eago.de/media/7d/f7/2e/1750709882/a50d4c1fc0a4473b16c5ebdd8059bd2f.jpg",
      "https://www.eago.de/media/f8/c9/dc/1750709883/bd9d757d72c053fd930c5c19fbc18591.jpg",
      "https://www.eago.de/media/6e/a4/b6/1750709883/3b3b3deca8cb59dec7ec78b959c74bea.jpg",
      "https://www.eago.de/media/4a/62/d3/1750709883/e5fcaf8364a2a3fd214b687bc7ef1a7e.jpg",
      "https://www.eago.de/media/7d/36/d8/1750709883/08830d3bda072e9e0daf178c9bcdf919.jpg",
      "https://www.eago.de/media/ee/d1/a6/1750709884/07b5e9400e4892a3ca29373426f945d2.jpg",
      "https://www.eago.de/media/21/57/ca/1750709884/08aaf7e5b3e542691a3df3d5907edf28.jpg",
      "https://www.eago.de/media/0b/02/0a/1750709884/d80fb544c1ac77423cf15cc2eb8dc30b.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 4 Personen",
      "Massagejets": "38 Jets",
      "Pumpen": "Hydropumpe LX 2200W, Zirkulationspumpe LX 180W",
      "Heizleistung": "2 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe SterlingSilver",
      "Wasserkapazität": "1250 Liter",
      "Gewicht (leer)": "300 kg",
      "Elektr. Absicherung": "1 × 16 A",
      "Anschluss": "Plug & Play – 230-V-Steckdose",
      "Außenmaße": "2000 × 2000 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Lassen Sie sich durch unsere SPA´s begeistern. Entspannen Sie in angenehmer Atmosphäre und stärken Sie so Ihr Immunsystem und ihren Kreislauf. Von dem Moment an, wo Sie sich in das warme, angenehme Wasser unserer AWT Aussenwhirlpools begeben, werden Sie den Alltag vergessen. Rückenschmerzen werden gelindert und Stress gehört der Vergangenheit an. Ihr Wohlbefinden wird hierdurch deutlich verbessert."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 4 Personen in Vollausstattung",
                  "38 Hydrojets (14 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "Energiesparende Hydropumpe von LX mit 2200W",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Webmodul zur Steuerung des Whirlpools per Smartphone oder Tablet.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade oder Party Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung (38 Lampen) unter den Kopfstürzen, im Filterbereich und im Pool",
                  "Beleuchteter Wasserfall",
                  "3 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (2kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe SterlingSilver",
                  "3 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Inkl. Treppe",
                  "Wasserkapazität 1250 Liter",
                  "Gewicht 300kg",
                  "Empfohlene elektrische Absicherung: 1 × 16 A (optional auch 2 × 16 A möglich)",
                  "Geräteanschluss: Plug & Play – einfach an eine 230-V-Steckdose anschließen und starten",
                  "2000mm x 2000mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-403-eco-sterling-silver-200x200-grau",
    "title": "AWT IN-403 Eco 200 × 200",
    "price": "5.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/7a/5f/db/1750710070/e909cd51a7e8ff2739a06afa0af1a86e.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/7a/5f/db/1750710070/e909cd51a7e8ff2739a06afa0af1a86e.jpg",
      "https://www.eago.de/media/40/ef/4d/1750710072/1b1abb8a5cdbcca5f1a74d9738fd5a83.jpg",
      "https://www.eago.de/media/70/aa/3d/1750710072/97d755875a678272e00ac898aa643395.jpg",
      "https://www.eago.de/media/2d/52/03/1750710072/8de21cf1137ebd661abc9ded18cc9d72.jpg",
      "https://www.eago.de/media/4e/9f/c1/1750710073/1729c1343add2cf68da698ec06204cc5.jpg",
      "https://www.eago.de/media/e0/a7/0f/1750710073/7126b4b9240d71c7bce0a0b385a635d9.jpg",
      "https://www.eago.de/media/eb/41/74/1750710073/5bd3647d67f0a1930900e92e492859fe.jpg",
      "https://www.eago.de/media/a6/a4/c1/1750710074/ab6917072549a3c92a5f68157d183052.jpg",
      "https://www.eago.de/media/d4/7e/39/1750710074/fb66b2bec893d1443fdcecfd98a5883a.jpg",
      "https://www.eago.de/media/da/ac/4f/1750710074/9cffac6f8010d4d2de81d7d97ca05098.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 5 Personen",
      "Massagejets": "38 Jets",
      "Pumpen": "Hydropumpe LX 2200W, Zirkulationspumpe LX 180W",
      "Heizleistung": "2 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe SterlingSilver",
      "Wasserkapazität": "1250 Liter",
      "Gewicht (leer)": "300 kg",
      "Elektr. Absicherung": "1 × 16 A",
      "Anschluss": "Plug & Play – 230-V-Steckdose",
      "Außenmaße": "2000 × 2000 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Lassen Sie sich durch unsere SPA´s begeistern. Entspannen Sie in angenehmer Atmosphäre und stärken Sie so Ihr Immunsystem und ihren Kreislauf. Von dem Moment an, wo Sie sich in das warme, angenehme Wasser unserer AWT Aussenwhirlpools begeben, werden Sie den Alltag vergessen. Rückenschmerzen werden gelindert und Stress gehört der Vergangenheit an. Ihr Wohlbefinden wird hierdurch deutlich verbessert."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 5 Personen in Vollausstattung",
                  "38 Hydrojets (14 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "Energiesparende Hydropumpe von LX mit 2200W",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Webmodul zur Steuerung des Whirlpools per Smartphone oder Tablet.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade oder Party Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung (40 Lampen) unter den Kopfstürzen, im Filterbereich und im Pool",
                  "Beleuchteter Wasserfall",
                  "3 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (2kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe SterlingSilver",
                  "3 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Inkl. Treppe",
                  "Wasserkapazität 1250 Liter",
                  "Gewicht 300kg",
                  "Empfohlene elektrische Absicherung: 1 × 16 A (optional auch 2 × 16 A möglich)",
                  "Geräteanschluss: Plug & Play – einfach an eine 230-V-Steckdose anschließen und starten",
                  "2000mm x 2000mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-404-eco-extreme-sterling-silver-225x225-grau",
    "title": "AWT IN-404 Premium 225 × 225",
    "price": "7.699,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/4e/b5/69/1750710382/4c6bb94eb549c5f9130e25eb3789bfe1.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/4e/b5/69/1750710382/4c6bb94eb549c5f9130e25eb3789bfe1.jpg",
      "https://www.eago.de/media/99/57/52/1750710383/63e4d87a4059978098cf34ca9a837635.jpg",
      "https://www.eago.de/media/17/3a/b8/1750710384/8b65665d62db46454e506cc70684e59f.jpg",
      "https://www.eago.de/media/c3/4b/8b/1750710384/9bf9a55b99496695d08b9f0ddd2aabaf.jpg",
      "https://www.eago.de/media/4c/d4/a6/1750710384/3313af55e9a01586511fd480f7f6e7ad.jpg",
      "https://www.eago.de/media/8b/5b/0d/1750710385/0158f4310f08bdeaf4de269dabd70e00.jpg",
      "https://www.eago.de/media/75/26/0a/1750710385/d949c9934cbc8086150f25593891de21.jpg",
      "https://www.eago.de/media/2a/48/1e/1750710385/5d82cca99f6130fa333497161fc5cade.jpg",
      "https://www.eago.de/media/10/02/ea/1750710386/ca846e9733bd896271369386e0535cef.jpg",
      "https://www.eago.de/media/e5/1e/e6/1750710386/fefedd5e7cc474ef34ab14307a407681.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 6 Personen",
      "Massagejets": "64 Jets",
      "Pumpen": "Hydropumpe LX 2200W, Zirkulationspumpe LX 180W",
      "Heizleistung": "2 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe SterlingSilver",
      "Wasserkapazität": "1450 Liter",
      "Gewicht (leer)": "320 kg",
      "Elektr. Absicherung": "3 × 16 A",
      "Anschluss": "Starkstrom, 3 Phasen (Powerbox Gecko)",
      "Außenmaße": "2250 × 2250 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Lassen Sie sich durch unsere SPA´s begeistern. Entspannen Sie in angenehmer Atmosphäre und stärken Sie so Ihr Immunsystem und ihren Kreislauf. Von dem Moment an, wo Sie sich in das warme, angenehme Wasser unserer AWT Aussenwhirlpools begeben, werden Sie den Alltag vergessen. Rückenschmerzen werden gelindert und Stress gehört der Vergangenheit an. Ihr Wohlbefinden wird hierdurch deutlich verbessert."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 6 Personen in Vollausstattung",
                  "64 Hydrojets (16 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "Zwei energiesparende Hydropumpen von LX mit 2200W / 1800W",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Webmodul zur Steuerung des Whirlpools per Smartphone oder Tablet.",
                  "Musikpaket mit zwei Lautsprechern - streamen der Lieblingsmusik oder Internetradio vom Smartphone.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade oder Party Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung (36 Lampen) unter den Kopfstürzen, im Filterbereich und im Pool",
                  "Beleuchteter Wasserfall5 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (2kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe SterlingSilver",
                  "3 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Inkl. Treppe",
                  "Wasserkapazität 1450 Liter",
                  "Gewicht 320kg",
                  "Empfohlene elektrische Absicherung 3 × 16 A",
                  "Geräteanschluss über 2 Phasen (Powerbox Gecko YJ3)",
                  "2250mm x 2250mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-405-eco-sterling-silver-220x160-grau",
    "title": "AWT IN-405 Eco 220 × 160",
    "price": "4.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/47/7c/3b/1750710469/ba2a17860e790532500214da05c8960a.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/47/7c/3b/1750710469/ba2a17860e790532500214da05c8960a.jpg",
      "https://www.eago.de/media/5a/2f/7e/1750710471/255e8b105192deaac7f34d0707091f64.jpg",
      "https://www.eago.de/media/45/b0/a6/1750710471/9a6f0e3d6d428ec67469aca40c8b7339.jpg",
      "https://www.eago.de/media/79/26/83/1750710471/c5ed0bbabccf3f9d6f14601ddcddf925.jpg",
      "https://www.eago.de/media/bc/fd/05/1750710472/b374b1efce56be5f18078a4a70619410.jpg",
      "https://www.eago.de/media/36/81/fa/1750710472/68ef223df1384fee0498b895aac94dcf.jpg",
      "https://www.eago.de/media/88/c8/a8/1750710472/80cc34620962dc0e104c1a3ee6208624.jpg",
      "https://www.eago.de/media/12/cb/78/1750710473/afcfd06f3d0e18ba87234e5259582809.jpg",
      "https://www.eago.de/media/97/5b/09/1750710473/7cd089c49358c3bd28cf569c084b70b3.jpg",
      "https://www.eago.de/media/2b/a9/9c/1750710473/9e92bb3c40ef5411e95b6efe61c7caac.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 3 Personen",
      "Massagejets": "37 Jets",
      "Pumpen": "Hydropumpe LX 2200W, Zirkulationspumpe LX 180W",
      "Heizleistung": "2 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe SterlingSilver",
      "Wasserkapazität": "950 Liter",
      "Gewicht (leer)": "250 kg",
      "Elektr. Absicherung": "1 × 16 A",
      "Anschluss": "Plug & Play – 230-V-Steckdose",
      "Außenmaße": "2200 × 1600 × 760 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Lassen Sie sich durch unsere SPA´s begeistern. Entspannen Sie in angenehmer Atmosphäre und stärken Sie so Ihr Immunsystem und ihren Kreislauf. Von dem Moment an, wo Sie sich in das warme, angenehme Wasser unserer AWT Aussenwhirlpools begeben, werden Sie den Alltag vergessen. Rückenschmerzen werden gelindert und Stress gehört der Vergangenheit an. Ihr Wohlbefinden wird hierdurch deutlich verbessert."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 3 Personen in Vollausstattung",
                  "37 Hydrojets (14 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "Energiesparende Hydropumpe von LX mit 2200W",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Webmodul zur Steuerung des Whirlpools per Smartphone oder Tablet.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade oder Party Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung (23 Lampen) unter den Kopfstürzen, im Filterbereich und im Pool",
                  "Beleuchteter Wasserfall",
                  "3 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (2kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe SterlingSilver",
                  "2 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Inkl. Treppe",
                  "Wasserkapazität 950 Liter",
                  "Gewicht 250kg",
                  "Empfohlene elektrische Absicherung: 1 × 16 A (optional auch 2 × 16 A möglich)",
                  "Geräteanschluss: Plug & Play – einfach an eine 230-V-Steckdose anschließen und starten",
                  "2200mm x 1600mm x 760mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-406-eco-extreme-sterling-silver-225x185-grau",
    "title": "AWT IN-406 Premium 225 × 185",
    "price": "7.299,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/4d/f6/b8/1750710516/b6d11b526767c0a105e6c475253c71ed.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/4d/f6/b8/1750710516/b6d11b526767c0a105e6c475253c71ed.jpg",
      "https://www.eago.de/media/fd/47/bf/1750710517/91b5bf15ac1de0a9d426e03634e1b118.jpg",
      "https://www.eago.de/media/d0/b4/00/1750710518/e97afd4632b9edc7c2cd3183e392ac41.jpg",
      "https://www.eago.de/media/e2/e1/46/1750710518/bb10dd37da8c2997ef7ef7f1c044a4af.jpg",
      "https://www.eago.de/media/df/cc/23/1750710518/559ca15b8036baa275750909c934251f.jpg",
      "https://www.eago.de/media/09/08/16/1750710519/89240db316f6a365acfe184a47e6aec5.jpg",
      "https://www.eago.de/media/fd/7c/76/1750710519/5ffe5f8b93fc51865908be4a3d264f69.jpg",
      "https://www.eago.de/media/dc/d4/13/1750710519/db9c9453642d149f5faa59d93998a6c0.jpg",
      "https://www.eago.de/media/2c/52/3d/1750710520/1342c8eeaf167ac0e2f0668f76722080.jpg",
      "https://www.eago.de/media/1c/3d/ea/1750710520/5378fa4f5a94700a025f479e9b5fb3e5.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 6 Personen",
      "Massagejets": "79 Jets",
      "Pumpen": "Zirkulationspumpe LX 180W",
      "Heizleistung": "2 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe SterlingSilver",
      "Wasserkapazität": "1300 Liter",
      "Gewicht (leer)": "320 kg",
      "Elektr. Absicherung": "3 × 16 A",
      "Anschluss": "Starkstrom, 3 Phasen (Powerbox Gecko)",
      "Außenmaße": "2250 × 1850 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Lassen Sie sich durch unsere SPA´s begeistern. Entspannen Sie in angenehmer Atmosphäre und stärken Sie so Ihr Immunsystem und ihren Kreislauf. Von dem Moment an, wo Sie sich in das warme, angenehme Wasser unserer AWT Aussenwhirlpools begeben, werden Sie den Alltag vergessen. Rückenschmerzen werden gelindert und Stress gehört der Vergangenheit an. Ihr Wohlbefinden wird hierdurch deutlich verbessert."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 6 Personen in Vollausstattung",
                  "79 Hydrojets (18 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "3 energiesparende Hydropumpen von LX (2 x 1800W, 1 x 2200W)",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Webmodul zur Steuerung des Whirlpools per Smartphone oder Tablet.",
                  "Musikpaket mit zwei Lautsprechern - streamen der Lieblingsmusik oder Internetradio vom Smartphone.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade oder Party Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung (36 Lampen) unter den Kopfstürzen, im Filterbereich und im Pool",
                  "Beleuchteter Wasserfall5 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (2kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe SterlingSilver",
                  "3 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Inkl. Treppe",
                  "Wasserkapazität 1300 Liter",
                  "Gewicht 320kg",
                  "Empfohlene elektrische Absicherung 3 × 16 A",
                  "Geräteanschluss über 2 Phasen (Powerbox Gecko YJ3)",
                  "2250mm x 1850mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-407-eco-sterling-silver-200x200-grau",
    "title": "AWT IN-407 Eco 200 × 200",
    "price": "5.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/4a/e2/00/1750710652/650932ca77560b1c64b9a6ff47bda8c8.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/4a/e2/00/1750710652/650932ca77560b1c64b9a6ff47bda8c8.jpg",
      "https://www.eago.de/media/bb/16/93/1750710654/9b2b3c1b77916bc57777465a7b4e40ad.jpg",
      "https://www.eago.de/media/50/d0/4c/1750710654/8a52de04418081b98283492b9c0caaed.jpg",
      "https://www.eago.de/media/33/ac/29/1750710654/f55e27b17bb20f240f245cad3eb8d1de.jpg",
      "https://www.eago.de/media/f8/35/02/1750710655/9bbc668c481035dc46771eb61ed46e47.jpg",
      "https://www.eago.de/media/ec/0f/f3/1750710655/6d60d4cc0d531768487775a20396ec71.jpg",
      "https://www.eago.de/media/97/95/9b/1750710655/4f5dced948c16cb620e101f3b486e634.jpg",
      "https://www.eago.de/media/e9/42/8a/1750710656/c9cde0fa0e67d37850cb2300830808b1.jpg",
      "https://www.eago.de/media/06/50/8a/1750710656/64d718b6a437b00e911cf24e04d3ca07.jpg",
      "https://www.eago.de/media/80/55/b6/1750710656/358731c19184a234faf709de4c9fc088.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 5 Personen",
      "Massagejets": "38 Jets",
      "Pumpen": "Hydropumpe LX 2200W, Zirkulationspumpe LX 180W",
      "Heizleistung": "2 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe SterlingSilver",
      "Wasserkapazität": "1250 Liter",
      "Gewicht (leer)": "300 kg",
      "Elektr. Absicherung": "1 × 16 A",
      "Anschluss": "Plug & Play – 230-V-Steckdose",
      "Außenmaße": "2000 × 2000 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Lassen Sie sich durch unsere SPA´s begeistern. Entspannen Sie in angenehmer Atmosphäre und stärken Sie so Ihr Immunsystem und ihren Kreislauf. Von dem Moment an, wo Sie sich in das warme, angenehme Wasser unserer AWT Aussenwhirlpools begeben, werden Sie den Alltag vergessen. Rückenschmerzen werden gelindert und Stress gehört der Vergangenheit an. Ihr Wohlbefinden wird hierdurch deutlich verbessert."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 5 Personen in Vollausstattung",
                  "38 Hydrojets (14 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "Energiesparende Hydropumpe von LX mit 2200W",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Webmodul zur Steuerung des Whirlpools per Smartphone oder Tablet.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade oder Party Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung (27 Lampen) unter den Kopfstürzen, im Filterbereich und im Pool",
                  "3 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (2kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe SterlingSilver",
                  "6 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Inkl. Treppe",
                  "Wasserkapazität 1250 Liter",
                  "Gewicht 300kg",
                  "Empfohlene elektrische Absicherung: 1 × 16 A (optional auch 2 × 16 A möglich)",
                  "Geräteanschluss: Plug & Play – einfach an eine 230-V-Steckdose anschließen und starten",
                  "2000mm x 2000mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-701-extreme-grundeinheit-sterling-silver-212x212-grau",
    "title": "AWT IN-701 Premium 212 × 212",
    "price": "7.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/45/b6/b3/1750798277/e114c469043e16cf0d6ee925b1da991a.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/45/b6/b3/1750798277/e114c469043e16cf0d6ee925b1da991a.jpg",
      "https://www.eago.de/media/d4/e0/7f/1750798278/586b6ee5f53c839e31df9151c00a79c2.jpg",
      "https://www.eago.de/media/3d/c4/4f/1750798278/d752f8f2bc64904aa803446f09032f6c.jpg",
      "https://www.eago.de/media/2d/b4/7a/1750798279/e7feb7adba4a08dfc8a73e07dacfebc7.jpg",
      "https://www.eago.de/media/af/04/f4/1750798279/fc179128d242a72c80dc21f7b9d0a3e5.jpg",
      "https://www.eago.de/media/cc/07/9c/1750798279/876474979fc78be80886451f7a9e788c.jpg",
      "https://www.eago.de/media/fc/38/a8/1750798280/4d8e01e8ab39bcbe9352b6e3beab6c61.jpg",
      "https://www.eago.de/media/2b/d4/fd/1750798280/4cdb1705fb6ca360978e04b85531fbfb.jpg",
      "https://www.eago.de/media/73/ae/df/1750798280/e9e7fc4aa0502be3d31e6bdd6bbbd520.jpg",
      "https://www.eago.de/media/c5/44/84/1750798280/506588bf26feb056ab8997608b5291a0.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 5 Personen",
      "Massagejets": "71 Jets",
      "Pumpen": "Hydropumpe LX 2200W, Zirkulationspumpe LX 180W",
      "Heizleistung": "3 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe SterlingSilver",
      "Wasserkapazität": "1300 Liter",
      "Gewicht (leer)": "320 kg",
      "Elektr. Absicherung": "3 × 20 A",
      "Anschluss": "Starkstrom, 3 Phasen (Powerbox Gecko)",
      "Außenmaße": "2120 × 2120 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Unsere neuste AWT SPA-Serie der 7xx-Serie bietet bereits in der Grundausstattung einen Luxus, den in dieser Preisklasse einmalig ist. Insbesondere die durch das Gecko IN.MIX System steuerbare Ambientebeleuchtung, die sowohl im Pool alle Jets und Steuerelemente umfasst, als auch von außen den Pool durch die Schürzenbeleuchtung gekonnt in Szene setzt schafft eine einzigartige Atmosphäre. Gegen Aufpreis ist der Pool auch in Vollausstattung mit Treppe, Web-Modul und Salzwasserdesinfektionsanlage lieferbar."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 5 Personen",
                  "71 beleuchtete Hydrojets (24 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "Zwei energiesparende Hydropumpen von LX mit 2200W",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Musikpaket mit zwei Lautsprechern - streamen der Lieblingsmusik oder Internetradio vom Smartphone.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung unter den Kopfstürzen, im Filterbereich und im Pool",
                  "Beleuchteter Wasserfall",
                  "4 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (3kW)",
                  "Ready for Heatpump. An diesem Pool lasst sich entweder sofort oder auch nachträglich eine Wärmepumpe anschließen",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe SterlingSilver",
                  "3 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Wasserkapazität 1300 Liter",
                  "Gewicht 320kg",
                  "Empfohlene elektrische Absicherung 3 × 20 A",
                  "Geräteanschluss über 3 Phasen (Powerbox Gecko YE5)",
                  "2120mm x 2120mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-702-extreme-grundeinheit-sterling-silver-212x212-grau",
    "title": "AWT IN-702 Premium 212 × 212",
    "price": "7.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/a3/54/39/1750798315/4752746d2d6a244b368beb35dba171d0.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/a3/54/39/1750798315/4752746d2d6a244b368beb35dba171d0.jpg",
      "https://www.eago.de/media/50/b0/74/1750798317/94fa9c5bfc173ac1eecbbf5feb7ef4ce.jpg",
      "https://www.eago.de/media/35/56/81/1750798317/1ee2955878c2cba7ded0bcb7456246ed.jpg",
      "https://www.eago.de/media/5c/7e/29/1750798317/d3ef0eb7b8889f4aa6ebd172e99c6165.jpg",
      "https://www.eago.de/media/87/d9/89/1750798318/b62c47a48d71dedda43b3e00fd38f88b.jpg",
      "https://www.eago.de/media/77/bc/27/1750798318/2576a8d08d8343ae0d956cc7327360cd.jpg",
      "https://www.eago.de/media/e5/b9/5e/1750798318/63a2719a28ee12dd21ea6f1d8a84cb41.jpg",
      "https://www.eago.de/media/e0/a7/0e/1750798319/4102bbb0558aae5cd21fe3aa354f242a.jpg",
      "https://www.eago.de/media/7f/a0/92/1750798319/4ef9e50cd9dc7fe7ff9bd4f551821e15.jpg",
      "https://www.eago.de/media/a0/a2/20/1750798319/6d70043b1cfcc48f707a566fd662aaef.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 6 Personen",
      "Massagejets": "72 Jets",
      "Pumpen": "Zirkulationspumpe LX 180W",
      "Heizleistung": "3 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe SterlingSilver",
      "Wasserkapazität": "1300 Liter",
      "Gewicht (leer)": "320 kg",
      "Elektr. Absicherung": "3 × 20 A",
      "Anschluss": "Starkstrom, 3 Phasen (Powerbox Gecko)",
      "Außenmaße": "2120 × 2120 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Unsere neuste AWT SPA-Serie der 7xx-Serie bietet bereits in der Grundausstattung einen Luxus, den in dieser Preisklasse einmalig ist. Insbesondere die durch das Gecko IN.MIX System steuerbare Ambientebeleuchtung, die sowohl im Pool alle Jets und Steuerelemente umfasst, als auch von außen den Pool durch die Schürzenbeleuchtung gekonnt in Szene setzt schafft eine einzigartige Atmosphäre. Gegen Aufpreis ist der Pool auch in Vollausstattung mit Treppe, Web-Modul und Salzwasserdesinfektionsanlage lieferbar."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 6 Personen",
                  "72 beleuchtete Hydrojets (21 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "3 energiesparende Hydropumpen von LX (2x 2200W / 1x 1800W)",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Musikpaket mit zwei Lautsprechern - streamen der Lieblingsmusik oder Internetradio vom Smartphone.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung unter den Kopfstürzen, im Filterbereich und im Pool",
                  "Beleuchteter Wasserfall7 beleuchtete Regler zur Luftbeimischung",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (3kW)",
                  "Ready for Heatpump. An diesem Pool lasst sich entweder sofort oder auch nachträglich eine Wärmepumpe anschließen",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe SterlingSilver",
                  "4 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Wasserkapazität 1300 Liter",
                  "Gewicht 320kg",
                  "Empfohlene elektrische Absicherung 3 × 20 A",
                  "Geräteanschluss über 3 Phasen (Powerbox Gecko YE5)",
                  "2120mm x 2120mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-703-extreme-grundeinheit-sterling-silver-225x225-grau",
    "title": "AWT IN-703 Premium 225 × 225",
    "price": "8.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/65/1f/d5/1750798348/b4e630ee2f38f5ac37613ae544de8e8c.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/65/1f/d5/1750798348/b4e630ee2f38f5ac37613ae544de8e8c.jpg",
      "https://www.eago.de/media/95/de/5d/1750798349/f07a68fc6df58026c36a0078609b600d.jpg",
      "https://www.eago.de/media/4d/d4/03/1750798350/1126a11ca800b9958664a76c2038a2db.jpg",
      "https://www.eago.de/media/f6/77/58/1750798350/a8ff2e62d795814ece1e7e1b16f4b3ff.jpg",
      "https://www.eago.de/media/6b/9c/b1/1750798350/82ffab45410a701c4ebfa5cefde4ef92.jpg",
      "https://www.eago.de/media/3e/54/5a/1750798350/79a48efee64dfa6df0a4376b9ad8b5b9.jpg",
      "https://www.eago.de/media/8e/de/a0/1750798351/3d34e264756ea282a39180370aad573e.jpg",
      "https://www.eago.de/media/5a/fd/1b/1750798351/2798aaade9380221798e2a1e75dfc84c.jpg",
      "https://www.eago.de/media/e8/f0/1c/1750798351/3ce17b9a294736208a14fed08dc14e83.jpg",
      "https://www.eago.de/media/d2/0b/4f/1750798352/6138e7f32e3fbdab8ea3a088df370550.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 6 Personen",
      "Massagejets": "92 Jets",
      "Pumpen": "Zirkulationspumpe LX 180W",
      "Heizleistung": "3 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe SterlingSilver",
      "Wasserkapazität": "1500 Liter",
      "Gewicht (leer)": "340 kg",
      "Elektr. Absicherung": "3 × 20 A",
      "Anschluss": "Starkstrom, 3 Phasen (Powerbox Gecko)",
      "Außenmaße": "2250 × 2250 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Unsere neuste AWT SPA-Serie der 7xx-Serie bietet bereits in der Grundausstattung einen Luxus, den in dieser Preisklasse einmalig ist. Insbesondere die durch das Gecko IN.MIX System steuerbare Ambientebeleuchtung, die sowohl im Pool alle Jets und Steuerelemente umfasst, als auch von außen den Pool durch die Schürzenbeleuchtung gekonnt in Szene setzt schafft eine einzigartige Atmosphäre. Gegen Aufpreis ist der Pool auch in Vollausstattung mit Treppe, Web-Modul und Salzwasserdesinfektionsanlage lieferbar."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 6 Personen",
                  "92 beleuchtete Hydrojets (30 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "3 energiesparende Hydropumpen von LX (2x 2200W / 1x 1800W)",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Musikpaket mit zwei Lautsprechern - streamen der Lieblingsmusik oder Internetradio vom Smartphone.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung unter den Kopfstürzen, im Filterbereich und im Pool",
                  "Beleuchteter Wasserfall7 beleuchtete Regler zur Luftbeimischung und zwei beleuchtete Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (3kW)",
                  "Ready for Heatpump. An diesem Pool lasst sich entweder sofort oder auch nachträglich eine Wärmepumpe anschließen",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe SterlingSilver",
                  "4 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Wasserkapazität 1500 Liter",
                  "Gewicht 340kg",
                  "Empfohlene elektrische Absicherung 3 × 20 A",
                  "Geräteanschluss über 3 Phasen (Powerbox Gecko YE5)",
                  "2250mm x 2250mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-704-premium-sterling-silver-220x160-grau",
    "title": "AWT IN-704 Premium 220 × 160",
    "price": "6.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/f6/45/be/1750798386/7f1ab41f6b0829eb936133f274149677.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/f6/45/be/1750798386/7f1ab41f6b0829eb936133f274149677.jpg",
      "https://www.eago.de/media/05/ab/a1/1750798387/f096cd89841e80ec41b16b53fdbfce78.jpg",
      "https://www.eago.de/media/fa/72/8e/1750798388/eae6493e68546131036f39a9ba250d13.jpg",
      "https://www.eago.de/media/05/22/ae/1750798388/ab4858b0fd366bf43c5d4964ced419aa.jpg",
      "https://www.eago.de/media/0e/3a/97/1750798388/dd0f5624ffb85d65abaf6142ed4cebf5.jpg",
      "https://www.eago.de/media/44/bf/f8/1750798388/af66c9399c1dd2f10d1004de0260a87e.jpg",
      "https://www.eago.de/media/1b/7d/f0/1750798389/f3387203fe7da63f35f52e84bdff9c24.jpg",
      "https://www.eago.de/media/36/07/a7/1750798389/fb9c9bec1eb978e02c081f051a1b69da.jpg",
      "https://www.eago.de/media/71/68/26/1750798389/b651a54da2d47106e6d1e67548906094.jpg",
      "https://www.eago.de/media/77/da/66/1750798390/1c5a591013f82a850b5f2f8328e8c9ef.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 3 Personen",
      "Massagejets": "50 Jets",
      "Pumpen": "Hydropumpe LX 1500W, Zirkulationspumpe LX 180W",
      "Heizleistung": "3 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl",
      "Wasserkapazität": "950 Liter",
      "Gewicht (leer)": "260 kg",
      "Elektr. Absicherung": "3 × 16 A",
      "Anschluss": "Starkstrom, 3 Phasen (Powerbox Gecko)",
      "Außenmaße": "2200 × 1600 × 760 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Unsere neuste AWT SPA-Serie der 7xx-Serie bietet bereits in der Grundausstattung einen Luxus, den in dieser Preisklasse einmalig ist. Insbesondere die durch das Gecko IN.MIX System steuerbare Ambientebeleuchtung, die sowohl im Pool alle Jets und Steuerelemente umfasst, als auch von außen den Pool durch die Schürzenbeleuchtung gekonnt in Szene setzt schafft eine einzigartige Atmosphäre. Gegen Aufpreis ist der Pool auch in Vollausstattung mit Treppe, Web-Modul und Salzwasserdesinfektionsanlage lieferbar."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 3 Personen",
                  "50 beleuchtete Hydrojets (16 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "2 energiesparende Hydropumpen von LX mit 1500W und 1100W",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Musikpaket mit zwei Lautsprechern - streamen der Lieblingsmusik oder Internetradio vom Smartphone.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung unter den Kopfstürzen, im Filterbereich und im Pool",
                  "Beleuchteter Wasserfall",
                  "4 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (3kW)",
                  "Ready for Heatpump. An diesem Pool lasst sich entweder sofort oder auch nachträglich eine Wärmepumpe anschließen",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe CloudyBlack",
                  "2 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)Wasserkapazität 950 Liter",
                  "Gewicht 260kg",
                  "Empfohlene elektrische Absicherung 3 × 16 A",
                  "Geräteanschluss über 3 Phasen (Powerbox Gecko YE5)",
                  "2200mm x 1600mm x 760mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-801-eco-sterling-silver-200x200-grau",
    "title": "AWT IN-801 Eco 200 × 200",
    "price": "5.499,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/28/0d/cc/1783611487/5ea6de6a90c50c0399518f70b2c1c21e.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/28/0d/cc/1783611487/5ea6de6a90c50c0399518f70b2c1c21e.jpg",
      "https://www.eago.de/media/02/86/f1/1783611487/dfb02624531f683b946aeb37afdb2b79.jpg",
      "https://www.eago.de/media/d1/c2/ac/1783611488/bccb24322d576e35aa225623e80efa1a.jpg",
      "https://www.eago.de/media/20/10/1e/1783611488/b1e56c3a5557f76687fffa0052db9679.jpg",
      "https://www.eago.de/media/55/f2/1e/1783611488/41d893383863dd1b67e5606116ba406f.jpg",
      "https://www.eago.de/media/57/e6/35/1783611488/dec9455bd1b5a93b502aaf5005f97d75.jpg",
      "https://www.eago.de/media/d6/66/a2/1783611489/ed4f2a515bfd9b166b20004167da583f.jpg",
      "https://www.eago.de/media/f4/53/7c/1783611489/2ca5cc1b76d32b5baaca1435392c565e.jpg",
      "https://www.eago.de/media/44/50/b2/1783611489/76fcb7202f423a38c4a15c3697766560.jpg",
      "https://www.eago.de/media/8e/13/a1/1783611489/36525a384ae6c927b90b551b315dec66.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 6 Personen",
      "Massagejets": "38 Jets",
      "Pumpen": "Hydropumpe LX 2200W, Zirkulationspumpe LX 180W",
      "Heizleistung": "2 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe Sterling Silver",
      "Wasserkapazität": "1250 Liter",
      "Gewicht (leer)": "310 kg",
      "Elektr. Absicherung": "1 × 16 A",
      "Anschluss": "Plug & Play – 230-V-Steckdose",
      "Außenmaße": "2000 × 2000 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Lassen Sie sich durch unsere SPA´s begeistern. Entspannen Sie in angenehmer Atmosphäre und stärken Sie so Ihr Immunsystem und ihren Kreislauf. Von dem Moment an, wo Sie sich in das warme, angenehme Wasser unserer AWT Aussenwhirlpools begeben, werden Sie den Alltag vergessen. Rückenschmerzen werden gelindert und Stress gehört der Vergangenheit an. Ihr Wohlbefinden wird hierdurch deutlich verbessert."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 6 Personen",
                  "38 Hydrojets (9 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "Energiesparende Hydropumpe von LX mit 2200W",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Webmodul zur Steuerung des Whirlpools per Smartphone oder Tablet.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade oder Party Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung (42 Lampen) unter den Kopfstürzen, im Filterbereich und im Pool",
                  "3 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (2kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe Sterling Silver",
                  "3 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Inkl. Treppe",
                  "Wasserkapazität 1250 Liter",
                  "Gewicht 310kg",
                  "Empfohlene elektrische Absicherung: 1 × 16 A (optional auch 2 × 16 A möglich)",
                  "Geräteanschluss: Plug & Play – einfach an eine 230-V-Steckdose anschließen und starten",
                  "2000mm x 2000mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-802-extreme-sterling-silver-212x212-grau",
    "title": "AWT IN-802 Extreme 212 × 212",
    "price": "8.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/3b/5a/ab/1783611519/24adba4256ff195a523e374591983f0c.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/3b/5a/ab/1783611519/24adba4256ff195a523e374591983f0c.jpg",
      "https://www.eago.de/media/0d/34/d9/1783611519/cd0faf6522a17412b8c4160480951719.jpg",
      "https://www.eago.de/media/16/8e/87/1783611520/c1a19d141e48ed1ee9eeea359f2b0d16.jpg",
      "https://www.eago.de/media/be/c0/6d/1783611520/dbb1c666e3d7ff538f57ac6b76b4b665.jpg",
      "https://www.eago.de/media/0f/a7/31/1783611520/01397a259c66c200a557216f289b1d21.jpg",
      "https://www.eago.de/media/82/3b/65/1783611520/10bf450e8c60bf2e8c5ee260c33c6d0d.jpg",
      "https://www.eago.de/media/57/92/b2/1783611521/f5c528456932df00ab58a17479c36309.jpg",
      "https://www.eago.de/media/af/7c/11/1783611521/fb4162249e0c787740567b6cecac177e.jpg",
      "https://www.eago.de/media/eb/61/53/1783611521/7b9d7964195bcd66daabd934f572ec70.jpg",
      "https://www.eago.de/media/c0/ee/80/1783611521/71f97542791c1d315e16011737f8424b.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 5 Personen",
      "Massagejets": "78 Jets",
      "Pumpen": "Hydropumpe LX 2200W, Zirkulationspumpe LX 180W",
      "Heizleistung": "3 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe Sterling Silver",
      "Wasserkapazität": "1300 Liter",
      "Gewicht (leer)": "320 kg",
      "Elektr. Absicherung": "3 × 16 A",
      "Anschluss": "Starkstrom, 3 Phasen (Powerbox Gecko)",
      "Außenmaße": "2120 × 2120 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung, Salzwasser-Desinfektionssystem",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Dieses Angebot umfasst einen Pool der neusten 7xx-Serie in Vollausstattung. Insbesondere die durch das Gecko IN.MIX System steuerbare Ambientebeleuchtung, die sowohl im Pool alle Jets und Steuerelemente umfasst, als auch von außen den Pool durch die Schürzenbeleuchtung gekonnt in Szene setzt schafft eine einzigartige Atmosphäre. In der Vollversion sind bereits Treppe, Web-Modul und Salzwasserdesinfektionsanlage enthalten."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 5 Personen in Vollausstattung",
                  "78 beleuchtete Hydrojets (25 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "2 energiesparende Hydropumpen von LX mit je 2200W",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Musikpaket mit zwei Lautsprechern - streamen der Lieblingsmusik oder Internetradio vom Smartphone.",
                  "Webmodul zur Steuerung des Whirlpools per Smartphone oder Tablet.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade oder Party Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung (50 Lampen) unter den Kopfstürzen, im Filterbereich und im Pool",
                  "3 beleuchtete Wasserfontänen",
                  "4 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (3kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Salzwasser-Desinfektionssystem (nicht vormontiert) - Reduziert den Pflegeaufwand für den Pool erheblich und schafft gleichzeitig ein weiches hautfreundliches Wasser",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe Sterling Silver",
                  "3 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Inkl. Treppe",
                  "Wasserkapazität 1300 Liter",
                  "Gewicht 320kg",
                  "Empfohlene elektrische Absicherung 3 × 16 A",
                  "Geräteanschluss über 3 Phasen (Powerbox Gecko YE5)",
                  "2120mm x 2120mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-803-extreme-sterling-silver-235x235-grau",
    "title": "AWT IN-803 Extreme 235 × 235",
    "price": "10.999,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/3d/fd/ab/1786703270/6de42f32f561c4715dcba96082b7a750.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/3d/fd/ab/1786703270/6de42f32f561c4715dcba96082b7a750.jpg",
      "https://www.eago.de/media/93/39/a6/1786703271/9affd90898b7114940435a16d531f050.jpg",
      "https://www.eago.de/media/33/ff/64/1786703271/39590d056afcfb1446b4c31b1efc5570.jpg",
      "https://www.eago.de/media/22/da/7a/1786703272/171ae11562c5454fb5efa635f953f573.jpg",
      "https://www.eago.de/media/0e/53/9e/1786703272/90c4ea46d9547f3ad0586069fa1f5a53.jpg",
      "https://www.eago.de/media/d2/0e/68/1786703272/5752173ed9961c779e41e72d15943517.jpg",
      "https://www.eago.de/media/cc/61/5e/1786703272/62eec85db9bd186fee7cc350a3c94e0d.jpg",
      "https://www.eago.de/media/19/75/00/1786703273/e70865693c2c5b1a5f9f5d30935f1f09.jpg",
      "https://www.eago.de/media/aa/5d/a8/1786703273/5445726fa3cdd64f64e8f42a40582474.jpg",
      "https://www.eago.de/media/ed/2e/d3/1786703273/6d20ab57af58cc6bd91a8a640353991c.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 6 Personen",
      "Massagejets": "110 Jets",
      "Pumpen": "Hydropumpe LX 2200W, Zirkulationspumpe LX 180W",
      "Heizleistung": "3 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe Sterling Silver",
      "Wasserkapazität": "1490 Liter",
      "Gewicht (leer)": "345 kg",
      "Elektr. Absicherung": "3 × 20 A",
      "Anschluss": "Starkstrom, 3 Phasen (Powerbox Gecko)",
      "Außenmaße": "2350 × 2350 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung, Salzwasser-Desinfektionssystem",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Dieses Angebot umfasst einen Pool der neusten 7xx-Serie in Vollausstattung. Insbesondere die durch das Gecko IN.MIX System steuerbare Ambientebeleuchtung, die sowohl im Pool alle Jets und Steuerelemente umfasst, als auch von außen den Pool durch die Schürzenbeleuchtung gekonnt in Szene setzt schafft eine einzigartige Atmosphäre. In der Vollversion sind bereits Treppe, Web-Modul und Salzwasserdesinfektionsanlage enthalten."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 6 Personen in Vollausstattung",
                  "110 beleuchtete Hydrojets (31 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "3 energiesparende Hydropumpen von LX mit je 2200W",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Musikpaket mit zwei Lautsprechern - streamen der Lieblingsmusik oder Internetradio vom Smartphone.",
                  "Webmodul zur Steuerung des Whirlpools per Smartphone oder Tablet.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade oder Party Modus für die totale EntspannungDezente LED-Beleuchtung (54 Lampen) unter den Kopfstürzen, im Filterbereich und im Pool",
                  "3 beleuchtete Wasserfontänen",
                  "3 beleuchtete Regler zur Luftbeimischung und zwei beleuchtete Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (3kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Salzwasser-Desinfektionssystem (nicht vormontiert) - Reduziert den Pflegeaufwand für den Pool erheblich und schafft gleichzeitig ein weiches hautfreundliches Wasser",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe Sterling Silver",
                  "3 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Inkl. Treppe",
                  "Wasserkapazität 1490 Liter",
                  "Gewicht 345kg",
                  "Empfohlene elektrische Absicherung 3 × 20 A",
                  "Geräteanschluss über 3 Phasen (Powerbox Gecko YE5)",
                  "2350mm x 2350mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  },
{
    "handle": "awt-in-804-extreme-sterling-silver-220x186-grau",
    "title": "AWT IN-804 Extreme 220 × 186",
    "price": "8.799,00 €",
    "cat": "Whirlpool",
    "img": "https://www.eago.de/media/eb/e9/50/1783611583/91166c23c6d3b044757d742cc155dd6b.jpg",
    "bg_id": "",
    "imgs": [
      "https://www.eago.de/media/eb/e9/50/1783611583/91166c23c6d3b044757d742cc155dd6b.jpg",
      "https://www.eago.de/media/4e/49/fd/1783611583/5d7ce9565aa44060c9c165782aa62b6d.jpg",
      "https://www.eago.de/media/9d/d6/37/1783611583/260d3d1c464e9923a983e229bdc6004d.jpg",
      "https://www.eago.de/media/68/6a/df/1783611584/35f9eb7901300727bf07280c4bc44d6e.jpg",
      "https://www.eago.de/media/72/0c/45/1783611584/ae6f94562870a4089c7b6820fc59265e.jpg",
      "https://www.eago.de/media/1c/4b/68/1783611584/bda344348321223748b04334a072344b.jpg",
      "https://www.eago.de/media/45/d1/8e/1783611584/e61ac844d40d7167cb6b1014a4d95252.jpg",
      "https://www.eago.de/media/81/4f/18/1783611585/745ced3d5f0eb437c34d190f0cb63474.jpg",
      "https://www.eago.de/media/48/05/fe/1783611585/1ce92f26378c576b7af63b37b8bae008.jpg",
      "https://www.eago.de/media/87/40/e8/1783611585/c7e89511f3f4590b2669a6560737093e.jpg"
    ],
    "pdf": "",
    "specs": {
      "Personenanzahl": "bis zu 6 Personen",
      "Massagejets": "64 Jets",
      "Pumpen": "Zirkulationspumpe LX 180W",
      "Heizleistung": "3 kW",
      "Steuerung": "Gecko Computersystem mit Farbdisplay",
      "Material": "Hochwertiges Acryl, Farbe Sterling Silver",
      "Wasserkapazität": "1000 Liter",
      "Gewicht (leer)": "305 kg",
      "Elektr. Absicherung": "3 × 16 A",
      "Anschluss": "Starkstrom, 3 Phasen (Powerbox Gecko)",
      "Außenmaße": "2200 × 1860 × 900 mm (L × B × H)",
      "Filtersystem": "Programmierbares Filtersystem, 6 m³ Durchsatz",
      "Wasseraufbereitung": "Ozon-Wasseraufbereitung, Salzwasser-Desinfektionssystem",
      "Lieferumfang": "Inkl. Treppe, isolierte Abdeckplane, alukaschierte Seitenverkleidung",
      "Lieferung": "Kostenlos innerhalb Deutschlands – Aufbauservice auf Anfrage"
    },
    "desc": [
      {
            "h": "Über dieses Modell",
            "text": "Dieses Angebot umfasst einen Pool der neusten 7xx-Serie in Vollausstattung. Insbesondere die durch das Gecko IN.MIX System steuerbare Ambientebeleuchtung, die sowohl im Pool alle Jets und Steuerelemente umfasst, als auch von außen den Pool durch die Schürzenbeleuchtung gekonnt in Szene setzt schafft eine einzigartige Atmosphäre. In der Vollversion sind bereits Treppe, Web-Modul und Salzwasserdesinfektionsanlage enthalten."
      },
      {
            "h": "Ausstattung & Lieferumfang",
            "items": [
                  "Exklusiver Design-Whirlpool für bis zu 6 Personen in Vollausstattung",
                  "64 beleuchtete Hydrojets (19 der Hydrojets sind mit Rotationsfunktion ausgestattet)",
                  "2 energiesparende Hydropumpen von LX (1x 2200W / 1x 1800W)",
                  "Energiesparende Zirkulationspumpe von LX mit 180W",
                  "Gecko Computersystem mit Farbdisplay, intuitiver Steuerung. Durch 5 vordefinierten Betriebsarten ist die Bedienung kinderleicht.",
                  "Selbstverständlich können auch individuelle Zeitpläne erstellt werden.",
                  "Musikpaket mit zwei Lautsprechern - streamen der Lieblingsmusik oder Internetradio vom Smartphone.",
                  "Webmodul zur Steuerung des Whirlpools per Smartphone oder Tablet.",
                  "Ambiente Farblicht (gesteuert über Gecko in.mix) mit vielen Funktionen wie Fade oder Party Modus für die totale Entspannung",
                  "Dezente LED-Beleuchtung (48 Lampen) unter den Kopfstürzen, im Filterbereich und im Pool",
                  "3 beleuchtete Wasserfontänen",
                  "3 beleuchtete Regler zur Luftbeimischung und ein beleuchteter Regler zur Steuerung der Flussrichtung des Wassers",
                  "Dezente Schürzenbeleuchtung (Farblicht) für einen tollen Lichteffekt",
                  "Heizung mit Temperaturwahl (3kW)",
                  "Wasserstandsensor zum Schutz der Pumpen",
                  "Effektives programmierbares Filter-System mit einem Wasserdurchsatz von 6qm",
                  "Salzwasser-Desinfektionssystem (nicht vormontiert) - Reduziert den Pflegeaufwand für den Pool erheblich und schafft gleichzeitig ein weiches hautfreundliches Wasser",
                  "Ozon-Wasseraufbereitung",
                  "Hochwertiges Acryl in der Farbe Sterling Silver",
                  "3 abnehmbare Kopfstützen",
                  "Langlebige und sehr massive Aluminiumkonstruktion",
                  "Geschlossene Bodenplatte aus GFK",
                  "Auslieferung komplett anschlussfertig inkl. Schürze",
                  "Inkl. alukaschierte Seitenverkleidung (40mm)",
                  "Inkl. stabiler isolierter Abdeckplane (80mm)",
                  "Inkl. Treppe",
                  "Wasserkapazität 1000 Liter",
                  "Gewicht 305kg",
                  "Empfohlene elektrische Absicherung 3 × 16 A",
                  "Geräteanschluss über 3 Phasen (Powerbox Gecko YE5)",
                  "2200mm x 1860mm x 900mm (Länge x Breite x Höhe)"
            ]
      }
    ]
  }
];

var CAT_LABELS = {
  'Hemlock':    'Hemlock Sauna',
  'Pinie':      'Pinienholz Sauna',
  'Zeder':      'rote Zeder Sauna',
  'Pappelholz': 'Pappelholz Sauna',
  'THE CUBE':   'THE CUBE – Gartensauna',
  'Whirlpool':  'AWT Whirlpool'
};

function buildGallery(bg_id, pics) {
  var n = pics || 5;
  var s = ['12'];
  for (var i = 1; i <= n; i++) s.push(String(i));
  return s.map(function(x){ return "https://www.eago.de/pix/bg"+bg_id+"-"+x+".jpg"; });
}

/* ── Produkt-Grid rendern ── */
function renderGrid(list) {
  var grid = document.getElementById("hc-grid");
  if (!grid) return;
  var html = "";
  list.forEach(function(p) {
    var catLabel = CAT_LABELS[p.cat] || p.cat;
    var title = p.title.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");
    html += '<div class="hc-product-card" data-cat="' + p.cat + '" data-handle="' + p.handle + '" onclick="openProduct(this.dataset.handle)" style="cursor:pointer">';
    html += '<div class="hc-card-image-wrap">';
    html += '<img src="' + p.img + '" alt="' + title + '" loading="lazy" onerror="this.style.display=\'none\';this.nextElementSibling.style.display=\'flex\'">';
    html += '<div class="hc-img-fallback" style="display:none;width:100%;height:100%;position:absolute;inset:0;align-items:center;justify-content:center;font-size:2.4rem;background:var(--bk-wood-light)"></div>';
    html += '<span class="hc-card-badge">' + p.cat + '</span>';
    html += '</div>';
    html += '<div class="hc-card-info">';
    html += '<div class="hc-card-category">' + catLabel + '</div>';
    html += '<div class="hc-card-title">' + title + '</div>';
    html += '<div class="hc-card-price-row"><div class="hc-card-price">' + p.price + '</div><span style="font-size:.8rem;color:var(--bk-muted);font-weight:500">Details →</span></div>';
    html += '</div>';
    html += '<button class="hc-card-atc-btn" data-atc="' + p.handle + '" onclick="event.stopPropagation();pdAddToCart(this.dataset.atc)">In den Warenkorb</button>';
    html += '</div>';
  });
  grid.innerHTML = html;
}

/* ──══════════════════════════════════════════
   PRODUKT-DETAIL → Weiterleitung auf echte Shopify-Produktseite
═════════════════════════════════════════════── */
function openProduct(handle) {
  window.location.href = '/products/' + handle;
}
function closeProduct() {
  // Nur für Rückwärtskompatibilität (Sub-Pages ohne Overlay)
  var ov = document.getElementById("pd-overlay");
  if (ov) { ov.classList.remove("open"); }
  document.body.style.overflow = "";
}

function pdSelectImg(src, thumb) {
  var mi = document.getElementById("pd-main-img");
  if (mi) mi.src = src;
  document.querySelectorAll(".pd-thumb").forEach(function(t){ t.classList.remove("active"); });
  if (thumb) thumb.classList.add("active");
}

/* ── Shopify Cart API: Varianten-ID per Handle ermitteln ── */
var _variantCache = {};
function _getVariantId(handle, callback) {
  if (_variantCache[handle]) { callback(_variantCache[handle]); return; }
  fetch('/products/' + handle + '.js')
    .then(function(r){
      if (!r.ok) throw new Error('not_found');
      return r.json();
    })
    .then(function(d){
      var vid = d.variants && d.variants[0] && d.variants[0].id;
      if (vid) _variantCache[handle] = vid;
      callback(vid || null);
    })
    .catch(function(){ callback(null); });
}

/* ── localStorage-Warenkorb Hilfsfunktionen ── */
function _lsCartGet() {
  try { return JSON.parse(localStorage.getItem('bk_cart') || '[]'); } catch(e) { return []; }
}
function _lsCartSave(items) {
  localStorage.setItem('bk_cart', JSON.stringify(items));
}
function _lsCartAdd(p) {
  var items = _lsCartGet();
  var existing = items.find(function(i){ return i.handle === p.handle; });
  if (existing) {
    existing.qty = (existing.qty || 1) + 1;
  } else {
    items.push({ handle: p.handle, title: p.title, price: p.price, img: p.img, cat: p.cat, qty: 1 });
  }
  _lsCartSave(items);
  /* Badge aktualisieren */
  var total = items.reduce(function(s,i){ return s + (i.qty||1); }, 0);
  document.querySelectorAll('.bk-cart-count').forEach(function(el){
    el.textContent = total > 0 ? total : '';
  });
}

/* ── In den Warenkorb (Grid + Overlay) ── */
function _bkToast(msg, ok) {
  var t = document.getElementById('bk-toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'bk-toast';
    t.style.cssText = [
      'position:fixed;bottom:24px;right:24px;z-index:9999',
      'padding:13px 20px;border-radius:10px;font-size:.85rem;font-weight:600',
      'color:#fff;box-shadow:0 4px 20px rgba(0,0,0,.22)',
      'transition:opacity .3s,transform .3s;opacity:0;transform:translateY(8px)',
      'max-width:320px;line-height:1.4;pointer-events:none'
    ].join(';');
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.style.background = ok ? '#2c7a4b' : '#c0392b';
  t.style.opacity = '1';
  t.style.transform = 'translateY(0)';
  clearTimeout(t._timer);
  t._timer = setTimeout(function(){
    t.style.opacity = '0';
    t.style.transform = 'translateY(8px)';
  }, 3200);
}

/* ── Warenkorb-Counter aktualisieren ── */
function _bkUpdateCartCount(delta) {
  document.querySelectorAll('.bk-cart-count').forEach(function(el) {
    var cur = parseInt(el.textContent, 10) || 0;
    var next = cur + (delta || 0);
    el.textContent = next > 0 ? next : '';
  });
}

/* ── In den Warenkorb (Grid + Overlay) ── */
function pdAddToCart(handle) {
  var p = PRODUCTS.find(function(x){ return x.handle === handle; });
  if (!p) return;

  var btn = document.querySelector('[data-atc="' + handle + '"]');
  if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt …'; }

  var priceNum = parseFloat((p.price||'0').replace(/[^0-9,]/g,'').replace(',','.')) || 0;

  function _trackEvents() {
    if (typeof gtag === 'function') {
      gtag('event', 'add_to_cart', {
        currency: 'EUR', value: priceNum,
        items: [{ item_id: handle, item_name: p.title, item_category: p.cat, price: priceNum, quantity: 1 }]
      });
    }
    if (typeof fbq === 'function') {
      fbq('track', 'AddToCart', { content_ids: [handle], content_name: p.title, currency: 'EUR', value: priceNum });
    }
  }

  function _btnReset() {
    if (btn) { btn.disabled = false; btn.textContent = 'In den Warenkorb'; }
  }

  _getVariantId(handle, function(variantId) {
    if (variantId) {
      /* ── Shopify Cart API (Produkt existiert in Shopify) ── */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (d.status) throw new Error(d.description || 'Fehler beim Hinzufügen');
        _bkToast('✓ In den Warenkorb gelegt', true);
        _bkUpdateCartCount(1);
        _trackEvents();
        _btnReset();
      })
      .catch(function(e){
        /* Shopify-Fehler → Fallback auf localStorage */
        _lsCartAdd(p);
        _bkToast('✓ In den Warenkorb gelegt', true);
        _trackEvents();
        _btnReset();
      });
    } else {
      /* ── Fallback: Shopify-Produkt noch nicht importiert → localStorage ── */
      _lsCartAdd(p);
      _bkToast('✓ In den Warenkorb gelegt', true);
      _trackEvents();
      _btnReset();
    }
  });
}

/* ── Sofort kaufen → direkt zum Checkout ── */
function pdBuyNow(handle) {
  var p = PRODUCTS.find(function(x){ return x.handle === handle; });
  if (!p) return;
  var btn = document.querySelector('[data-buy="' + handle + '"]');
  if (btn) { btn.disabled = true; btn.textContent = 'Weiterleiten …'; }
  _getVariantId(handle, function(variantId) {
    if (variantId) {
      window.location.href = '/cart/' + variantId + ':1';
    } else {
      /* Fallback: Produkt noch nicht in Shopify → in den Warenkorb und zur Cart-Seite */
      _lsCartAdd(p);
      window.location.href = '/cart';
    }
  });
}

/* ── Initial rendern ── */
renderGrid(PRODUCTS);

/* ── Tab-Navigation ── */
function showPage(id, btn) {
  // In Shopify: URL-Navigation statt DOM-Toggle
  var urlMap = {
    'home': '/',
    'ueber': '/pages/ueber-uns',
    'kontakt': '/pages/kontakt',
    'faq': '/pages/faq',
    'impressum': '/pages/impressum',
    'agb': '/pages/agb',
    'widerruf': '/pages/widerruf',
    'datenschutz': '/pages/datenschutz'
  };
  if (urlMap[id]) {
    window.location.href = urlMap[id];
  }
}

/* ── FAQ Toggle ── */
function bkToggleFaq(btn) {
  var item = btn.closest(".faqp-item");
  var isOpen = item.classList.contains("open");
  document.querySelectorAll(".faqp-item.open").forEach(function(i){ i.classList.remove("open"); });
  if (!isOpen) item.classList.add("open");
}

/* ── Filter-State ── */
var _activeCat   = "all";
var _activePrice = "all";
var _activePers  = "all";

/* Preis-String "3.699,00 €" → Zahl 3699 */
function _parsePrice(priceStr) {
  return parseFloat((priceStr || "0").replace(/[^0-9,]/g, "").replace(",", ".")) || 0;
}

/* Preis-Match */
function _priceMatch(p, range) {
  var v = _parsePrice(p.price);
  if (range === "all")     return true;
  if (range === "low")     return v < 4000;
  if (range === "mid")     return v >= 4000  && v < 8000;
  if (range === "high")    return v >= 8000  && v < 15000;
  if (range === "premium") return v >= 15000;
  return true;
}

/* Personen-Match: exakt auf Bestuhlung-Werte gemappt
   "1–2 Personen" → max=2
   "2–3 Personen" → max=3
   "2–4 Personen" → max=4
   "3–5 Personen" → max=5
   "4–6 Personen" → max=6  */
function _persMatch(p, range) {
  if (range === "all") return true;
  var str = (p.specs && (p.specs["Bestuhlung"] || p.specs["Personenanzahl"])) || "";
  var m = str.match(/(\d+)\D+(\d+)/);
  var min, max;
  if (m) {
    min = parseInt(m[1], 10);
    max = parseInt(m[2], 10);
  } else {
    var single = str.match(/(\d+)/);
    min = single ? parseInt(single[1], 10) : 0;
    max = min;
  }
  if (range === "s2") return max <= 2;             /* nur 1–2 */
  if (range === "s4") return max <= 4;             /* 1–2, 2–3, 2–4 */
  if (range === "s5") return max <= 5;             /* 1–2, 2–3, 2–4, 3–5 */
  if (range === "s6") return max >= 5;             /* 3–5, 4–6 */
  return true;
}

/* Gemeinsamer Filter */
function _applyFilters() {
  var filtered = PRODUCTS.filter(function(p) {
    return (_activeCat === "all" || p.cat === _activeCat) &&
           _priceMatch(p, _activePrice) &&
           _persMatch(p, _activePers);
  });
  renderGrid(filtered);
  var count = filtered.length;
  var catLabelEl = document.getElementById("hc-active-cat-label");
  if (catLabelEl) catLabelEl.textContent = _activeCat === "all" ? "Alle Produkte" : (_activeCat === "Whirlpool" ? "Whirlpools" : _activeCat + " Saunen");
  var pcEl = document.getElementById("hc-product-count");
  if (pcEl) pcEl.textContent = count + " Modelle";
  var gc = document.getElementById("hc-grid-count");
  if (gc) {
    var _unitLabel;
    if (_activeCat === "Whirlpool") { _unitLabel = count === 1 ? " Whirlpool" : " Whirlpools"; }
    else if (_activeCat === "all")   { _unitLabel = " Produkte"; }
    else                             { _unitLabel = count === 1 ? " Sauna" : " Saunen"; }
    gc.textContent = count + _unitLabel;
  }
  /* Selects: is-active Klasse wenn nicht "all" */
  var ps = document.getElementById("hc-price-select");
  if (ps) ps.classList.toggle("is-active", _activePrice !== "all");
  var prs = document.getElementById("hc-pers-select");
  if (prs) prs.classList.toggle("is-active", _activePers !== "all");
  /* Reset-Button */
  var resetBtn = document.getElementById("hc-filter-reset");
  if (resetBtn) {
    resetBtn.style.display = (_activeCat !== "all" || _activePrice !== "all" || _activePers !== "all") ? "inline-flex" : "none";
  }
  /* Keine-Ergebnisse-Hinweis */
  var emptyEl = document.getElementById("hc-empty");
  var gridEl  = document.getElementById("hc-grid");
  if (emptyEl) emptyEl.style.display  = count === 0 ? "block" : "none";
  if (gridEl)  gridEl.style.display   = count === 0 ? "none"  : "";
}

/* ── Holzart-Filter (Chip-Buttons) ── */
function hcFilter(cat, btn) {
  _activeCat = cat;
  document.querySelectorAll(".hc-chip").forEach(function(b){ b.classList.remove("active"); });
  if (btn) btn.classList.add("active");
  _applyFilters();
}

/* ── Preis-Filter (Select) ── */
function hcSetPrice(range) {
  _activePrice = range;
  _applyFilters();
}

/* ── Personen-Filter (Select) ── */
function hcSetPersons(range) {
  _activePers = range;
  _applyFilters();
}

/* ── Alle Filter zurücksetzen ── */
function hcResetFilters() {
  _activeCat   = "all";
  _activePrice = "all";
  _activePers  = "all";
  document.querySelectorAll(".hc-chip").forEach(function(b){ b.classList.remove("active"); });
  var allChip = document.querySelector('.hc-chip[data-cat="all"]');
  if (allChip) allChip.classList.add("active");
  var ps = document.getElementById("hc-price-select");
  if (ps) ps.value = "all";
  var prs = document.getElementById("hc-pers-select");
  if (prs) prs.value = "all";
  _applyFilters();
}

/* ── ESC zum Schließen ── */
document.addEventListener("keydown", function(e) {
  if (e.key === "Escape") closeProduct();
});


/* ── COOKIE-BANNER ─────────────────────────────────────── */
(function() {
  if (!localStorage.getItem('bk_cookie_consent')) {
    setTimeout(function() {
      var b = document.getElementById('cookie-banner');
      if (b) b.classList.add('visible');
    }, 800);
  }
})();
function cookieAccept() {
  localStorage.setItem('bk_cookie_consent', 'all');
  var b = document.getElementById('cookie-banner');
  if (b) { b.style.transition = 'transform .3s'; b.style.transform = 'translateY(100%)'; }
}
function cookieReject() {
  localStorage.setItem('bk_cookie_consent', 'necessary');
  var b = document.getElementById('cookie-banner');
  if (b) { b.style.transition = 'transform .3s'; b.style.transform = 'translateY(100%)'; }
}

/* ── KONTAKTFORMULAR: Handler entfernt ────────────────────
   Der Submit-Handler fuer #kontakt-form lebt jetzt ausschliesslich
   inline in sections/main-kontakt.liquid (inkl. Honeypot, dynamischem
   Betreff und Formspree-Fehlerauswertung). Ein zusaetzlicher Handler
   hier fuehrte zu doppelten Formspree-Submits (2 E-Mails pro Anfrage). */
